//English  提示：只需要翻译冒号:后面的英文即可。
export const language = {
    //2020-10-26-ljm增加 弹窗提示以及翻译
    meassage:{
      leanMore:'Apprendre encore plus',
      skip:'Sauter',
      activate:'Activer',
      emailSend: 'Email sent!',
      },
  leftBanner: {
      liteWebsite: 'Sauvegarde du site web',
      liteClone: 'Clonage de site web',
      liteFile: 'Lite File',
      logoSlogan: 'The Go-To Choice for Cloud Transfer',
      cloudEscription: 'MultCloud – Le Choix Incontournable pour le Transfert de Données entre Clouds',
      commonTools: 'Outils Communs',
      cloudDrives: 'Mon Cloud',
      onlineServices: 'Mes services en ligne',
      switchTxt: 'MultCloud classique',
      taskList: 'Liste des Tâches',
      cloudTransfer: 'Transfert de Cloud',
      cloudSync: 'Synchronisation de Cloud',
      cloudBackup:'Sauvegarde de Cloud',
      btLink: 'Téléchargement à distance',
      teamTransfer:'Transfert d\'équipe',
      shares: 'Partage',
      emailTransfer: 'Migration E-mail',
      instagramDownload: 'Téléchargeur Instagram',
      videoDownload: 'Téléchargeur de vidéos',
      webDownload: 'Téléchargeur d’images',
      addCloud: 'Ajouter des clouds',
      addEmail: 'Ajouter des clouds et des e-mails',
      manageClouds: 'Gérer clouds & e-mails',
      manageClouds2: 'Gérer clouds',
      encryption: 'Cryptage',
      edit: 'Rajouter',
      remove: 'Supprimer',
      createTask: 'Créer une tache',
      createTaskText: 'Vous pouvez créer les tâches les plus courantes ici.',
      gotIt: 'Bien reçu',
      bigWriteEncrypt: 'Cryptage',
      encryptionText: 'Vous pouvez configurer le cryptage des fichiers cloud ici.',
      addCloudText: 'Cliquez ici pour connecter votre lecteur cloud et votre e-mail à MultCloud.',
      inviteFriends: 'Inviter des amis',
      switchTip:'Passer au MultCloud classique',
      switchTipDes:'Vous pouvez passer au MultCloud classique ici.',
      new: 'Nouveau',
  },
  common: {
      dropFilesToUpload: 'Déposez les fichiers ici pour les envoyer dans le dossier actuel',
      uploadUnavailable: 'Les fichiers ne peuvent pas être envoyés ici dans cet état',
      listView: 'Vue en liste',
      gridView: 'Vue en grille',
      sortBy: 'Trier par',
      ascending: 'Ordre croissant',
      descending: 'Ordre décroissant',
      addCloud: 'Ajouter un Cloud',
      addEmail: 'Ajouter un e-mail',
    options: 'Options',
      schedule: 'Planifier',
      ok: 'OK',
      save: 'Enregistrer',
      add: 'Ajouter',
      upgradeNow: 'Mettre à niveau',
      addWebsite: 'Ajouter un site web',
      websiteName: 'Nom du site web',
      websiteTip: 'Cliquez ici pour ajouter le site web que vous souhaitez sauvegarder.',
      continue: 'Continuer',
      overwriteTip: 'Si les fichiers ou bases de données du site cible existent déjà, cette restauration les écrasera. Voulez-vous continuer ?',
      overwriteTip2: 'Si les fichiers ou bases de données du site cible existent déjà, ce clonage les écrasera. Voulez-vous continuer ?',
      from: 'De',
      to: 'à',
      result: 'Résultat',
      fileProcess: 'Fichiers Traitées',
      transferFiles:'Des dossiers',
      dataProcess: 'Données Traitées',
      startTime: 'Heure de début',
      currentRate: 'Taux actuel',
      endTime: 'Heure de fin',
      timeRemaining: 'Temps restant',
      averageRate: 'Taux moyen',
      averageRateSpecial: 'Avg.Rate',
      viewFailed: 'Cliquez pour voir les fichiers ayant échoué',
      fileSuccess: 'Réussi au transfert de tous les fichiers',
      size: 'Taille',
      path: 'Chemin',
      setUp: 'Configurer',
      backups: 'Sauvegardes',
      restoreTo: 'Restaurer vers',
      restoreNewLocation: 'Restaurer vers un nouvel emplacement',
      executedTimes: 'Temps exécutés',
      sourceDir: 'Répertoire source',
      cause: 'Cause',
      retry: 'Réessayer',
      retryMin: 'Réessayer',
      clean: 'Nettoyer',
      properties: 'Propriétés',
      copy: 'Copier',
      move: 'Déplacer',
      multiSelect: 'Multi-Sélection',
      close: 'fermer',
      copyTo: 'Copier vers',
      tranTo: 'Transférer vers',
      syncWith: 'Synchroniser avec',
      backupTo: 'Sauvegarder vers',
      download: 'Télécharger',
      delete: 'Supprimer',
      more: 'Plus',
      preview: 'Aperçu',
      share: 'Partager',
      shareWith: 'Partager avec MultCloud',
      shareTransfer: 'Effectuer un transfert',
      encrypt: 'Crypter',
      encryptFile: 'Crypter le fichier uniquement',
      encryptFileName: 'Crypter le fichier et le nom',
      decrypt: 'Décrypter',
      decryptFile: 'Décrypter le fichier uniquement',
      decryptFileName: 'Décrypter le fichier et le nom',
      onedriveBusinessContentNote: 'Remarque',
      oneDrive4BusinessContent: 'Si vous êtes un administrateur et avez attribué une licence Microsoft 365 à un utilisateur, mais que vous recevez une erreur « Accès refusé » lorsque vous essayez d\'accéder au dossier d\'un utilisateur via MultCloud, essayez les étapes suivantes :',
      oneDrive4BusinessTips1: `Allez dans « <a href="https://admin.microsoft.com/" target="_blank" class='add-onedrivebuiness-link'>Admin</a> ». Sélectionnez « Utilisateurs » > l\'onglet « Utilisateurs actifs » > Sélectionnez l\'option « Gérer la licence du produit ».`,
      oneDrive4BusinessTips2: 'Accédez à l\'onglet « OneDrive » et cliquez sur « Créer un lien vers un fichier ». Revenez ensuite à MultCloud et essayez à nouveau d’accéder au compte.',
      oneDrive4BusinessStep1: 'Étape 1',
      oneDrive4BusinessStep2: 'Étape 2',
      upStep: 'Précédent',
      nextStep: 'Suivant',
      complete: 'Compléter',
      cut: 'Couper',
      viewDetails: 'Afficher les détails',
      toOfficialSite: 'Site officiel',
      btLinkTask: 'Tache à distance',
      fileName: 'Nom de fichier',
      itemsSelected: 'éléments sélectionnés',
      dateModified: 'Date Modifiée',
      rename: 'Renommer',
      paste: 'Coller',
      btLink: 'Téléchargement à distance',
      load: 'En Chargement',
      status: 'Statut',
      operate: 'Exploiter',
      failure: 'échec',
      link: 'Lien',
      cleanList: 'Nettoyer la liste',
      type: 'Type',
      account: 'Compte',
      name: 'Nom',
      selectFailedFile: 'Veuillez sélectionner le fichier ayant échoué',
      transferring: 'Transfert',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      done: 'fait',
      no: 'Non',
      yes: 'Oui',
      attention: 'Attention',
      cancel: 'Annuler',
      unsubscribe: 'Se désabonner',
      reactivate: 'Réactivez-le',
      sureCleanAll: "Êtes-vous sûr d'effacer toutes les tâches terminées ?",
      failedFiles: 'Fichiers ayant échoué',
      minTo: 'à',
      retryAll: 'Réessayer tout',
      viewProgress: 'Afficher les progrès',
      taskNotRun: 'Cette tache n\'est pas en cours d\' exécution.',
      success: 'Succès',
      failure: 'échec',
      canceled: 'Annulé',
      patial: 'Succès partiel',
      syncDetails: 'Détails de synchronisation',
      width: 'Largeur',
      sync: 'Synchronisation',
      targetCloud: 'Cloud cible',
      running: 'En cours d\'exécution ',
      preparing: 'En préparation',
      waiting: 'en attente',
      target: 'Cible',
      noVip: 'Vous avez maintenant un maximum de 2 fichiers transférés simultanément. Passez à un service premium pour en avoir un maximum de 10 !',
      vipThanks: 'Merci d\'avoir souscrit à notre service.Vous avez maintenant un maximum de 10 fichiers transférés simultanément.',
      emailAccount: 'Compte email',
      with: 'Avec',
      syncing: 'Synchronisation',
      selectAll: 'Sélectionner tous',
      date: 'Date',
      failed: 'Échoué',
      skip: 'Ignorer',
      replace: 'Remplacer',
      ready: 'Prêt',
      connecting: 'En connexion',
      account: 'Compte',
      selectNull: 'Veuillez sélectionner un répertoire cible.',
      selectOther: 'Ce répertoire ne peut pas être sélectionné pour coller des fichiers, vous pouvez sélectionner ses sous-répertoires ou d\'autres répertoires.',
      //2020-10-26-ljm新增
      filterHolder:'Entrez une extension de fichier ici. Eg., mp4',
      countFiles:'Compter les fichiers',
      //2020-8-18-xth新增
      editShare: 'Éditer Partage',
      toSource: 'Vers Source',
      copyLink: 'Copier le lien',
      toShare: 'Vers Partage',
      report: 'Signaler',
      expand: 'Étendre',
      shrink: 'Réduire',
      //2020-12-2-ljm新增
      upgradeMulti:'Passer au multithreading',
      team: "Fichiers d'équipe",
      loadData:'Chargement des données, veuillez patienter',
      getAccountInfo:'Impossible d\'obtenir les informations du compte, veuillez vous reconnecter et réessayer.',
      loadingData:'Chargement des données...',
      failedEmptyTip: 'Impossible de charger les fichiers échoués. Veuillez contacter <a href="mailto:support@multcloud.com">support@multcloud.com</a> pour une assistance supplémentaire.',
      runNow:'Exécuter maintenant',
      emailFilter: 'Filtre d\'e-mails',
      me: "Moi",
      reset: "Réinitialiser",
      apply: "Appliquer",
      failureReason: 'Cause de l\'échec',
      countingFilesTip: 'Calcul ({num} fichiers)',
      taskName: 'Nom de la Tâche',
      frequency: 'Fréquence :',
      canceling: 'Annulation en cours...',
  },
  rightTopBanner: {
    navTransfer: 'Transfert de Cloud à cloud',
    navInstagram: 'Téléchargeur Instagram',
    navVideo: 'Téléchargeur de vidéos',
    navWeb: 'Téléchargeur d\'images',
    traffic: 'Trafic',
    upgrade: 'Mettre à niveau',
    settings: 'Paramètres',
    changePassword: 'Changer le mot de passe',
    changeName: 'Changer le nom',
    bindEmail: 'Lier l\'e - mail ',
    deleteAccount: 'Supprimer le compte',
    language: 'Langue',
    help: 'Aide',
    notifications: 'Notifications',
    notification: 'Mises à jour',
    subAccounts: 'Sous-comptes',
    logout: 'Déconnexion',
    tutorials: 'Tutoriels',
    contact: 'Contacter',
    limitsClouds: 'Limites des Clouds',
    faq: 'FAQ',
    purTraffic: 'Acheter du trafic',
    unlimitedPlan: 'Plan illimité',
    monthlyUnlimitedPlan: 'Plan mensuel illimité',
    rememberOriginal: 'Veuillez vous souvenir de votre nom d\'utilisateur d\'origine :',
    andPassword: 'et mot de passe',
    bindEmailOpen: 'Il est préférable de <span style="color:#8a96e3;cursor:pointer;" id="bindEmailOpen">lier votre adresse e-mail et de changer le mot de passe par défaut</span> pour plus de sécurité et de commodité. ',
    lifeSwitchTip: 'Avec le service DURÉE DE VIE ILLIMITÉE, vous pouvez transférer des fichiers entre des clouds sans limites de trafic.',
    lifeTimePlan: 'Illimité à vie',
    browserPrompt:'Pour une meilleure expérience utilisateur, nous vous suggérons d\'utiliser Google Chrome.',
    unlimited:'Illimité',
    lifeTimeNotice:'Vous êtes un utilisateur de MultCloud Illimité à vie.',
    subAccount:"Sous-compte",
    bindMailTips:"Veuillez attacher votre e-mail pour déverrouiller le transfert fichiers Cloud et tirer le meilleur parti de MultCloud.",
    bind:"Attacher",
  },
  liteApp: {
    menu: 'Mes applications',
    title: 'Mes applications',
    edit: 'Modifier',
    warning: 'Avertissement',
    description: 'Gérez les applications OAuth utilisées pour connecter des services cloud.',
    addApp: 'Ajouter une application',
    empty: 'Vous n’avez ajouté aucune application personnalisée.',
    appType: 'Service cloud',
    appName: 'Nom de l’application',
    clientId: 'ID client / clé d’application',
    clientSecret: 'Secret client / secret d’application',
    callback: 'URI de redirection',
    secretUnchanged: 'Laissez vide pour ne pas modifier',
    inUse: 'Utilisée',
    usedTip: 'Cette application est utilisée par un ou plusieurs lecteurs cloud. Ses identifiants ne peuvent pas être modifiés.',
    nameRequired: 'Veuillez saisir un nom d’application.',
    credentialsRequired: 'Veuillez saisir l’ID client et le secret client.',
    secretRequiredForKey: 'Saisissez le secret client lorsque vous modifiez l’ID client.',
    deleteConfirm: 'Supprimer cette application personnalisée ? Les lecteurs cloud qui l’utilisent doivent d’abord être supprimés.',
    appInUse: 'Cette application est utilisée par un lecteur cloud et ne peut pas être supprimée ni voir ses identifiants modifiés.',
    nameExists: 'Une application portant ce nom existe déjà pour ce service cloud.',
    systemAppUnavailable: 'L’application par défaut de MultCloud est indisponible pour ce service cloud.',
    selectApp: 'Application',
    defaultApp: 'Utiliser l’application par défaut de MultCloud',
    selectAppTip: 'Choisissez l’application utilisée pour autoriser ce service cloud.',
    copySuccess: 'Copié dans le presse-papiers',
  },
  popup: {
    userStarPopup: {
        starDesc: "Comment se passe votre expérience jusqu’à présent ?",
        ok: "OK",
        thankYou: "Merci!",
        thankYouDesc: "Si vous pouviez prendre un moment pour partager votre expérience réelle et honnête d'utilisation de notre produit, cela aiderait notre petite équipe à rester motivée pour rendre MultCloud encore meilleur.",
        reviewStart: "Évaluez-nous sur",
        reviewEnd: "",
        feedbackTitle: "Comment pouvons nous nous améliorer?",
        feedbackDesc: "Ajoutez vos commentaires",
        feedbackBtn: "Soumettre",
        feedbackYes: "Merci pour vos commentaires.",
        feedbackNo: "Veuillez entrer vos commentaires.",
    },
      addCloudPopup: {
          endpointOptional:'Point de terminaison (facultatif)',
          regionOptional: 'Région (facultatif)',
          bucketOptional: 'Bucket (facultatif)',
          //2020.09.23 添加NAS云盘
          addNas: 'Ajouter NAS',
          addNasFtpDes: `Connectez le NAS via FTP. Vous ne savez pas comment configurer FTP pour NAS <a href="https://www.multcloud.com/help/enable-ftp-service-on-synology-nas.html" target="_blank" class='add-cloud-link'>cliquer ici</a>`,
          addNasWebDes: `Connectez le NAS via WebDAV. Vous ne savez pas comment configurer WebDAV pour NAS <a href="https://www.multcloud.com/help/enable-webdav-service-on-synology-nas.html" target="_blank" class='add-cloud-link'>cliquer ici</a>`,
          bucketName: 'Nom du compartiment',
          accessKeyId: 'Accès ID de clé',
          idriveKeyId: 'Access Key ID',
          endpoint: 'Endpoint',
          secretAccessKey: 'Clé d\'accès secrète ',
          idriveSecretAccessKey: 'Secret Access Key',
          displayName: 'Affichier le nom',
          addFtp: 'Ajouter FTP',
          addFtpDes: 'Pour connecter votre FTP, vous devez entrer vos détails d\'authentification.',
          egnyteTip:  `Notes : Pour obtenir votre Key et votre Secret, vous aurez besoin de l'ID de gestion de l'API Egnyte. Si vous n'en avez pas, vous pouvez <a href="https://developers.egnyte.com/member/register" target="_blank" class='add-cloud-link'>vous inscrire ici</a>.`,
          icedriveTip: 'Note :',
          icedriveTip1: '1. Prend en charge uniquement les comptes Premium d\'Icedrive.',
          icedriveTip2:`2. Cliquez sur votre nom d'utilisateur Icedrive -> 2FA et accès -> WebDAV -> Activer -> Afficher la clé. La clé d'accès est le mot de passe.`,
          iCloudPhotosTip: 'Conseils:',
          iCloudPhotosTip1: '1. Avant de connecter vos Photos iCloud à MultCloud, assurez-vous que « Accéder aux données iCloud sur le Web » est activé.',
          iCloudPhotosTip1Q: `Comment gérer l'accès Web à vos données iCloud :<br><br>Sur iPhone ou iPad<br>1. Ouvrez l'application Réglages.<br>2. Appuyez sur votre nom, puis appuyez sur iCloud.<br><br>3. Appuyez pour désactiver ou activer Accéder aux données iCloud sur le Web.<br>
          <br>Sur Mac<br>1. Choisissez le menu Pomme > Réglages système.<br>2. Cliquez sur votre nom, puis cliquez sur iCloud.<br>3. Cliquez pour désactiver ou activer Accéder aux données iCloud sur le Web.`,
          iCloudPhotosTip2: '2. Photos iCloud prend en charge uniquement les formats d\'image suivants : jfif, pjpeg, jpeg, pjp, jpg, HEIC.',
          iCloudGuideIntro: "Pour ajouter {cloud} à MultCloud, veuillez vérifier les points suivants :",
          iCloudAuthCountry: "Pays/Région",
          iCloudAuthCountryDefault: "Par défaut",
          iCloudAuthCountries: {
              US: "États-Unis",
              DE: "Allemagne",
              FR: "France",
              JP: "Japon",
              PT: "Portugal",
              IT: "Italie",
              NL: "Pays-Bas",
              ES: "Espagne",
          },
          iCloudGuideStep1: `1. « Accès aux données iCloud sur le Web » est activé.`,
          iCloudGuideIOS: `Sur iPhone ou iPad :`,
          iCloudGuideIOSInstructions: `Accédez à Réglages > [votre nom] > iCloud > iCloud.com, puis activez « Autoriser l’accès aux données ».`,
          iCloudGuideMac: `Sur Mac :`,
          iCloudGuideMacInstructions: `Accédez au menu Apple > Réglages Système > [votre nom] > iCloud > Accès aux données sur iCloud.com, puis activez « Autoriser l’accès aux données ».`,
          iCloudGuideStep2: `2. Assurez-vous que l’appareil recevant le code de vérification est connecté au bon compte Apple.`,
          iCloudGuideStep2Instructions: `Lors de l’autorisation, Apple envoie un code de vérification à un appareil connecté au compte Apple que vous souhaitez associer à MultCloud. Assurez-vous que l’appareil utilisé pour recevoir le code est connecté à ce même compte.`,
          iCloudPhotosGuideFormats: `Remarque : Photos iCloud prend en charge uniquement les formats d’image suivants : jfif, pjpeg, jpeg, pjp, jpg, HEIC.`,
          iCloudGuideViewImage: `Agrandir l’image du tutoriel`,
          iCloudGuideImageAlt: `Configuration de {cloud}, étape {step}`,
          iCloudDomainTip: 'Si votre compte iCloud appartient à la région Chine, veuillez vous assurer de sélectionner www.icloud.com.cn dans le champ Domaine.',
          googleDrive2FATip: 'Conseils pour l\'authentification à 2 facteurs de Google Drive',
          googleDrive2FATip1: 'Veuillez vous assurer de cocher « Voir, modifier, créer et supprimer tous vos fichiers Google Drive » sur la page d\'autorisation Google Drive.',
          server: 'serveur',
          protocol: 'Protocole',
          port: 'Port',
          passive: 'Mode passif',
          passphrase: 'Phrase de passe',
          explanation: 'Pour se connecter au FTP, le préfixe doit être "ftp://" ou le préfixe est manquant. Si votre port FTP n\'est pas par défaut,c \'est un numéro de port spécial, tel que 21, veuillez utiliser le format pour spécifier le port ci-dessous : ftp://ftp.myhost.com:21',
          userName: 'Nom d\'utilisateur ',
          passWord: 'Mot de passe',
          advanced: 'Avancé',
          commFTP: 'FTP',
          transMode: 'Mode de transfert',
          encoding: 'Encoding',
          path: 'Path(facultatif)',
          cloudName: 'Nom de Cloud',
          cloudService: 'Service de Cloud',
          addedTime: 'Temps ajouté',
          userName: 'Nom d\'utilisateur ',
          usedSpace: 'Espace utilisé',
          totalSpace: 'Espace total',
          iCloudUsedSpace: 'Stockage de Photos iCloud',
          iCloudDriveUsedSpace: 'Stockage de iCloud Drive',
          iCloudTotalSpace: 'Stockage total d\'iCloud',
          iCloudDriveTotalSpace: 'Stockage total d\'iCloud',
          removeContent: 'Certaines tâches de transfert cloud sont basées sur ce cloud. Voulez-vous toujours le supprimer ?',
          google_driveTips: 'Lorsque vous transférez des fichiers ou des dossiers de Google Drive vers un autre, assurez-vous qu\'il n \'y a pas les mêmes noms de fichiers dans le même répertoire.',
          baiDuTips: 'Vous ne pouvez charger ou transférer des fichiers que dans le répertoire "全部文件/我的应用数据/MultCloud".',
          mySQLQuestion: 'Vous devez entrer votre adresse IP du serveur MySQL dans le champ serveur et le port par défaut est 3306 ou vous devez saisir votre port personnalisé.',

          webDavQuestion: `Si vous utilisez une connexion SSL sécurisée, ajoutez le préfixe « https:// » à votre hôte ou ne faites rien et le port par défaut est 443, sinon, le préfixe doit être « http:// » et le port par défaut est 80.
            Par exemple, https://dav.box.com/dav`,

          egnyteQuestion: 'Connectez-vous à Engnyte et trouvez votre domaine dans la barre d\'adresse. Veuillez saisir le domaine au format suivant : par exemple, https://aomeitech.egnyte.com/',

          ownCloudQuestion: 'Si vous utilisez une connexion SSL sécurisée, ajoutez le préfixe « https:// » à votre hôte ou ne faites rien et le port par défaut est 443, sinon, le préfixe doit être « http:// » et le port par défaut est 80',

          amazonQuestion: `Visitez la page pour savoir <a href="https://www.multcloud.com/tutorials/s3-key.html" target="_blank" class='add-cloud-link'>comment obtenir l\'ID de clé pour l\'accès à Amazon S3.</a>`,

          boxTips: `Box ne prend pas en charge le transfert de fichiers uniques de plus de 2 Go.`,
google_drive_sharedWithMeTips:'Lorsque vous transférez des fichiers vers des dossiers de Partagé avec moi drive, assurez-vous que vous êtes autorisé avec « Autorisation de chargement ».',
          gSuiteSharedDriveTips:'Lorsque vous transférez des fichiers vers des dossiers de Drive partagé, assurez-vous que vous êtes autorisé avec « Autorisation de chargement ».',
          webDavTips: `1.Veuillez vous assurer que vous disposez des autorisations de lecture/écriture avant les opérations des fichiers, sinon MultCloud risque de ne pas pouvoir transférer des fichiers vers WebDav.
          2. Veuillez vous assurer qu\'il y a suffisamment d\'espace pour vos opérations. Nous sommes temporairement incapables d\'identifier sa taille.`,
          aDriveTips: 'Nous prenons actuellement en charge les comptes premium personnels et les comptes d\'entreprise, mais pas les comptes de base personnels.',
          yandexTips: `1.Veuillez vous assurer qu\'il y a suffisamment d\'espace pour vos opérations. Nous sommes temporairement incapables d\'identifier sa taille.
                       2.Si vous avez activé le mot de passe de l'application, veuillez saisir le mot de passe de l'application dans la barre de mot de passe ci-dessus.`,
          googlePhotosTips: `1.Le répertoire « Photos » ne peut stocker que des images, des vidéos et d\'autres fichiers multimédias, mais pas des répertoires.
          2.Le répertoire « Albums » ne peut stocker que les répertoires d\'album, mais pas les fichiers multimédias.
          3.Le répertoire « Partage » contient tous les albums que vous avez partagés ou les albums partagés que vous avez rejoints.
          4.Google Photos prend uniquement en charge le chargement d\'images, de vidéos et d\'autres fichiers multimédias. Et lorsque vous utilisez la fonction de chargement de MultCloud, vous ne pouvez charger que des fichiers dans les répertoires d\'album créés ou partagés par MultCloud.
          5.Lorsque vous utilisez la fonction de partage de source de MultCloud, vous ne pouvez partager que les albums créés par MultCloud.
          6.Tous les albums sans titre seront affichés comme « Sans titre ».
          7.Actuellement, la fonction de téléchargement est disponible, mais le téléchargement des fichiers d\'origine n\'est pas pris en charge.
          8.Actuellement, il n\'y a pas de support pour les fonctions de couper, supprimer et renommer. Et vous ne pouvez pas utiliser les fonctions qui dépendent de ces opérations.`,
          googlePhotosV2Tips: `1.Le répertoire « Photos » ne peut stocker que des images, des vidéos et d\'autres fichiers multimédias, mais pas des répertoires.
          2.Le répertoire « Albums » ne peut stocker que les répertoires d\'album, mais pas les fichiers multimédias.`,

          evernoteTips: `1. Limites de taux d\'API. <a href='https://dev.evernote.com/doc/articles/rate_limits.php' target="_blank" class='add-cloud-link'> Voir les détails >> </a>
            2. Quelles sont les limites système d\'Evernote ? <a href='https://help.evernote.com/hc/en-us/articles/209005247-What-are-the-system-limits-of-Evernote-' target="_blank" class='add-cloud-link'>Voir les détails >></a>
            3. Vous pouvez charger uniquement un fichier de moins de 50 Mo dans la note.
            4. Impossible de renommer ou de supprimer les fichiers de contenu des notes (.ENML).
            5. Peut copier uniquement les notes dans le carnet.`,

          flickrTips: `1. Vous pouvez transférer uniquement des photos ou des vidéos sur Flickr.
          2. Les dossiers ne peuvent être transférés que dans le répertoire « Albums » et il ne peut pas y avoir de sous-répertoires dans le répertoire « Albums ».
          3. Les fichiers ne peuvent être transférés que dans le répertoire « My Photostream » ou « Albums » que vous créez.
          4. Tous vos fichiers se trouvent dans le répertoire « My Photostream ».
          5. Tous les fichiers du répertoire « Albums » sont référencés dans le répertoire « My Photostream ».`,

          mediafireTips: 'Le chargement et le téléchargement d\'un fichier vide ne sont pas pris en charge. L\'ouverture d\'un dossier contenant de nombreux fichiers peut prendre du temps.',

          mySQLTips: `1. Votre base de données doit être accessible à partir de nos adresses IP, qui sont 209,126.%. Vous pouvez créer un nouvel utilisateur via votre base de données ou votre interface hôte, la commande MySQL est la suivante :
          <span class='add-mysql-link'>GRANT SHOW DATABASES, SELECT, LOCK TABLES, RELOAD ON *.* TO username@'209.126.%' IDENTIFIED BY 'password';</span>
          2. Votre serveur peut avoir besoin d\'ajouter une règle de pare-feu avec nos adresses IP et le port auquel nous avons accédé (le port par défaut est 3306) pour accéder normalement à vos bases de données.`,
          hubiCTips: `1. Un compte hubiC ne peut être ajouté qu\'une seule fois.
          2. Vous ne pouvez pas renommer et couper des fichiers ou des dossiers.
          3. Il peut être un peu lent de supprimer des dossiers contenant de nombreux fichiers.
          4. hubiC ne prend pas en charge la transmission d\'un seul fichier supérieur à 5 Go.
          5. Les noms de fichiers ne peuvent pas dépasser 248 caractères et les noms de dossier sont limités à 256 caractères.`,

          gSuiteUpTips: `La connexion entre G Suite et MultCloud n\'est disponible que pour les administrateurs G Suite. Pour connecter G Suite à MultCloud, vous devez d\'abord « INSTALLER LE DOMAINE » notre application G Suite Marketplace ---<a href='https://gsuite.google.com/marketplace/search/Cloud%20Transfer%20-%20MultCloud?hl=en' target="_blank" class='add-cloud-link'> « Cloud Transfer - MultCloud »</a>.`,

          gSuiteTips: `1.Vous devez être <a href="https://support.google.com/a/answer/2405986?hl=en" target="_blank" class='add-cloud-link'> administrateur G Suite</a>.
                      2.Comment vérifier s\'il s\'agit d\'un compte administrateur ? Tout d\'abord, reportez-vous à ce lien <a href='https://support.google.com/a/answer/2406043' target="_blank" class='add-cloud-link'> https://support.google.com/a/answer/2406043</a>. Ensuite, connectez-vous à votre compte Gsuite à partir du lien. Troisièmement, vous pouvez trouver les résultats sous la ligne « Pour créer un rôle personnalisé ».
                      3.L'<a href='https://support.google.com/a/answer/60757?hl=en' target="_blank" class='add-cloud-link'>accès API </a> est activé.
                      4.Avant d\'ajouter ce disque cloud, vous devez d\'abord installer notre <a href='https://gsuite.google.com/marketplace?hl=en' target="_blank" class='add-cloud-link'> application G Suite Marketplace </a> « MultCloud pour G Suite » et vous assurer que sa <a href='https://admin.google.com/' target="_blank" class='add-cloud-link'> configuration </a> est correcte : l\'état est activé et l\'accès aux données est accordé.`,

          google_workspaceTips: `1. Le répertoire racine Google Workspace et le répertoire de chaque membre servent uniquement à parcourir les membres et les catégories. Vous ne pouvez pas y téléverser de fichiers ni créer de dossiers.
          2. My Drive (Google Drive Root) : il s'agit du répertoire racine Google Drive personnel du membre. Les opérations disponibles dépendent des autorisations Google Drive du membre.
          3. Shared drives : les opérations disponibles dépendent du rôle du membre dans le lecteur partagé et des autorisations du dossier.
          4. Shared with me : il s'agit d'une liste des éléments partagés avec le membre, et non d'un dossier physique. Vous ne pouvez pas y téléverser directement des fichiers ni créer de dossiers. Dans un dossier partagé, le téléversement et la création de dossiers sont possibles uniquement avec l'autorisation Éditeur ; les lecteurs et les commentateurs disposent d'un accès en lecture seule.`,
          hiDriveTips: `1.Veuillez vous assurer d'avoir un compte avec le protocole WebDAV activé et des autorisations de lecture/écriture avant de travailler avec des fichiers, sinon MultCloud pourrait ne pas être en mesure de transférer des fichiers sur votre HiDrive.
          2. Veuillez vous assurer qu\'il y a suffisamment d\'espace pour vos opérations. Nous sommes temporairement incapables d\'identifier sa taille.`,
          backblazeTips: `1.Chaque nom de compartiment doit contenir au moins 6 caractères.
          2.Lorsque vous créez une nouvelle clé d\'application, l\'ancienne ne fonctionnera plus.
          3.Les noms de fichier ne peuvent pas commencer par « / », se terminer par « / » ou contenir « // ».`,
          WEBDETips: `1.Veuillez vous assurer que vous disposez des autorisations de lecture/écriture avant les opérations sur les fichiers, sinon, MultCloud peut ne pas être en mesure de transférer des fichiers dans votre Web.De.
          2. Veuillez vous assurer qu\'il y a suffisamment d\'espace pour vos opérations. Nous sommes temporairement incapables d\'identifier sa taille.`,
          alfrescoTips: `En tant que compte Alfresco gratuit, votre espace de stockage pour le réseau est de 10 Go et la taille de fichier individuelle est de 50 Mo.`,
          cloudMeTips: `1.Veuillez vous assurer que vous disposez des autorisations de lecture/écriture avant les opérations sur les fichiers, sinon MultCloud peut ne pas être en mesure de transférer des fichiers dans votre CloudMe.
          2. Veuillez vous assurer qu\'il y a suffisamment d\'espace pour vos opérations. Nous sommes temporairement incapables d\'identifier sa taille.`,
          myDriveTips: `Veuillez vous assurer qu\'il y a suffisamment d\'espace pour vos opérations. Nous sommes temporairement incapables d\'identifier sa taille.`,
          cubbyTips: `1.Veuillez vous assurer que vous disposez des autorisations de lecture/écriture avant les opérations sur les fichiers, sinon, MultCloud peut ne pas être en mesure de transférer des fichiers dans votre Cubby.
          2. Veuillez vous assurer qu\'il y a suffisamment d\'espace pour vos opérations. Nous sommes temporairement incapables d\'identifier sa taille.`,
          cloudType: 'Type de Cloud',

          notificationTip: `Merci d\'avoir utilisé la dernière version de MultCloud, si vous avez des questions, veuillez donner des commentaires à <a href="mailto:support@multcloud.com">support@multcloud.com</a>,merci.`,

          notAbleAccess: 'Le problème d\'accès à Google Photos a été résolu',

          problemNotAccess: 'Le problème d\'accès à Google Photos a été résolu. Si vous ne pouvez toujours pas accéder à Google Photos, veuillez l\'ajouter à nouveau à MultCloud.',

          noPrompt: 'Ne plus inviter la prochaine fois',
          addFeatures: 'Quelques nouvelles fonctionnalités ajoutées ci-dessous :',
          version: 'Version:',
          releasedOn: 'Publié le ',
          newLabel: 'Nouveau :',
          improvedLabel: 'Amélioré :',
          noteLabel: 'Remarque :',
          tryNewFeatures: 'Essayez ces nouvelles fonctionnalités maintenant et améliorez votre expérience de gestion de fichiers avec MultCloud !',
          okButton: 'OK',
        notif_v885: `Sauvegarde de site : sauvegardez facilement les fichiers ou bases de données d’un site dans le cloud et restaurez-les si nécessaire. Clonage de site : copiez-les facilement vers un autre site.`,
        notif_v884: `La hauteur de la liste des clouds a été augmentée pour faciliter la gestion de plusieurs comptes.`,
        notif_v881: `Autorisation iCloud améliorée avec codes de vérification de l’appareil ; MultCloud Plus optimisé et connexion rapide Facebook rétablie.`,
        notif_v880: `Lancement de MultCloud Plus : transferts cloud et services sélectionnés dans une expérience plus légère, avec un meilleur taux de réussite.`,
        notif_v870: `Les fichiers Dropbox Paper et Google Drive non pris en charge sont exclus ; taux de réussite SFTP amélioré et tâches temporaires bloquées corrigées.`,
        notif_v831: `Correction des tâches temporaires en échec affichées comme réussies et des tâches de transfert bloquées en attente.`,
        notif_v830: `Correction des tâches planifiées qui ne s’exécutaient pas à l’heure ; activation des comptes payants par code ajoutée.`,
        notif_v780: `Ajout d’outils Web de téléchargement vidéo et Instagram sans installation ; taux de réussite FTP amélioré.`,
        notif_v760: `Les dates originales des fichiers sont conservées après synchronisation.`,
        notif_v750: `Taux de réussite des transferts Google Photos amélioré.`,
          notif_v740: `<b>Téléchargeur de vidéos en ligne</b>
<div>Téléchargez des vidéos de haute qualité depuis YouTube, Facebook, X, TikTok et plus de 1000 autres sites grâce au téléchargeur de vidéos en ligne sans publicité et multiplateforme de MultCloud — aucune installation requise.</div>
<b>Essayez ces nouvelles fonctionnalités maintenant et améliorez votre expérience de gestion de fichiers avec MultCloud !</b>`,
          notif_v730: `<b>Téléchargeur d'images Web</b>
<div>Collectez facilement des images depuis n'importe quel site Web ou recherche Google en entrant une URL ou un mot-clé et enregistrez-les directement dans votre stockage cloud ou sur votre appareil local.</div>
<b>Essayez ces nouvelles fonctionnalités maintenant et améliorez votre expérience de gestion de fichiers avec MultCloud !</b>`,
          notif_v720: `<div>Nous sommes ravis d'annoncer de nouvelles fonctionnalités et améliorations dans MultCloud :</div>
<ol class="imagesaver_versions">
<li><b>Téléchargeur Instagram :</b><div>Vous pouvez désormais facilement télécharger du contenu Instagram ! Avec le nouveau téléchargeur Instagram, les utilisateurs peuvent télécharger ou uploader des photos de profil, publications, Reels, Stories et Highlights Instagram directement vers le stockage cloud ou vers votre appareil local.</div></li>
<li><div>La fonctionnalité de téléchargeur de vidéos et de téléchargeur d'images sera également bientôt disponible.</div></li>
</ol>`,
          notif_v710: `<div>Nous sommes ravis de présenter la nouvelle fonctionnalité Enregistreur d'images dans MultCloud ! Voici les détails des nouvelles fonctionnalités :</div>
<ol class="imagesaver_versions">
<li><b>Enregistrer des images et vidéos Instagram</b>
<ul class="imagesaver_version">
<li type="disc"><b>Prise en charge de plusieurs liens : </b>Enregistrez des images et vidéos à partir de 1 à 3 liens Instagram simultanément.</li>
<li type="disc"><b>Upload et téléchargement faciles : </b>Choisissez d'uploader les médias directement vers votre stockage cloud ou de les télécharger sur votre appareil local.</li>
</ul></li>
<li><b>Enregistrer des images de sites Web</b>
<ul class="imagesaver_version">
<li type="disc"><b>Prise en charge de plusieurs liens : </b>Enregistrez des images à partir de 1 à 3 liens de sites Web à la fois.</li>
<li type="disc"><b>Options de stockage flexibles : </b>Uploadez des images directement vers votre stockage cloud préféré ou téléchargez-les localement.</li>
</ul></li>
<li><b>Enregistrer des images de recherche Google</b>
<ul class="imagesaver_version">
<li type="disc"><b>Recherche par mot-clé : </b>Entrez un mot-clé pour rechercher des images sur Google.</li>
<li type="disc"><b>Enregistrement direct : </b>Uploadez facilement les résultats de recherche vers votre stockage cloud ou téléchargez-les sur votre ordinateur.</li>
</ul></li>
</ol>`,
          notif_v700: `<div>MultCloud prend désormais en charge 4shared et lDrive e2.</div>`,
          notif_v630: `<div>MultCloud prend désormais en charge Icedrive.</div>`,
          notif_v620: `<div>Extensions Chrome : MultCloud Save - Enregistrer une page Web au format PDF.</div>`,
          notif_v550: `<div>MultCloud prend désormais en charge Outlook.</div>`,
          notif_v530: `<div>MultCloud prend désormais en charge iCloud Drive.</div>`,
          notif_v520: `<div>MultCloud prend désormais en charge Gmail.</div>`,
          notif_v500: `<div>MultCloud prend désormais en charge iCloud Photos.</div>`,
          notif_v490: `<div>Corrections de bugs sur la sauvegarde et la restauration cloud.</div>`,
          notif_v487: `<div>Le stockage en ligne SharePoint est pris en charge.</div>`,
          notif_v485: `<div>Transfert de partage.</div>
<div>Avec cette fonctionnalité, vous pouvez facilement envoyer de gros fichiers à n'importe qui.</div>
<b>Guide rapide :</b>
<div>1.Faites un clic droit sur le fichier que vous souhaitez envoyer (pour sélectionner le fichier, veuillez d'abord ajouter à MultCloud le cloud où se trouve le fichier).</div>
<div>2.Accédez à « Partager » et sélectionnez « Créer un transfert ».</div>`,
          notif_v482: `<div>Wasabi Cloud ajouté.</div>
<div>Les utilisateurs de Wasabi peuvent désormais connecter Wasabi à MultCloud.</div>`,
          notif_v480: `<div>Transfert d'équipe.</div>
<div>Migration facile des clouds professionnels d'un tenant à un autre. Google Workspace (et Shared Drive), OneDrive for Business, Dropbox Business, Box for Business pris en charge.</div>`,
          notif_v470: `<div>Fonctionnalité de sauvegarde et restauration cloud à cloud ajoutée.</div>`,
          notif_v468: `<div>Tous les clouds sont pris en charge pour la synchronisation en temps réel.</div>
<b>Amélioré :</b>
<div>Interface améliorée sur la page de partage.</div>`,
          notif_v467: `<div>Les tâches de synchronisation cloud à cloud prennent désormais en charge la synchronisation en temps réel.</div>
<b>Amélioré :</b>
<div>Améliorations de vitesse pour les nouvelles tâches de transfert et de synchronisation.</div>`,
          notif_v465: `<div>1.Nouvelle interface publiée.</div>
<div>2.Prise en charge du téléchargement de torrents vers le cloud.</div>`,
          notif_v457: `<div>1.Ajout du NAS.</div>`,
          notif_v456: `<div>1.Correction du problème d'accès impossible à Google Photos.</div>`,
          notif_v455: `<div>1.Amélioration de la fonction de partage de MultCloud pour du trafic gratuit.</div>`,
          notif_v454: `<div>1.Ajout de la fonction de transfert multi-sources.</div>
<div>2.Ajout du chiffrement et déchiffrement de fichiers en ligne.</div>
<div>3.Ajout de l'option de chiffrement du nom de fichier à la fonction de chiffrement de fichiers.</div>`,
          notif_v453: `<div>1.Optimisation du cloud Dropbox for Business.</div>`,
          notif_v452: `<div>1.Nouvelle fonctionnalité premium : chiffrement des fichiers lors de l'upload.</div>`,
          notif_v451: `<div>1.Améliorations du serveur de transport MultCloud.</div>
<div>2.Mise à jour des forfaits gratuit et premium.</div>`,
          notif_v450: `<div>1.Ajout d'une corbeille pour certains clouds.</div>
<div>2.Modification de certaines interfaces de notre site Web.</div>
<div>3.Optimisation de certaines fonctions.</div>`,
          notif_v444: `<div>1.Ajout de Google Photos et Put.io.</div>`,
          notif_v443: `<div>1.Ajout de la fonction de synchronisation unidirectionnelle multi-cibles.</div>`,
          notif_v442: `<div>1.Ajout de Backblaze.</div>`,
          notif_v441: `<div>1.Ajout de Google Drive pour G Suite.</div>`,
          notif_v440: `<div>1.Ajout de la gestion des sous-comptes.</div>
<div>2.Amélioration du cloud Google Drive.</div>
<div>3.Correction de certains bugs de lecteurs cloud.</div>`,
          notif_v431: `<div>1.Amélioration de la fonction d'autorisation OneDrive for Business et résolution du problème empêchant certains utilisateurs d'ajouter ce cloud.</div>
<b>Remarque :</b>
<div>Veuillez ajouter à nouveau votre cloud OneDrive for Business et les tâches de transfert si vous avez déjà ajouté ce cloud, désolé pour la gêne occasionnée.</div>`,
          notif_v430: `<div>1.Ajout de la prise en charge du lecteur pCloud.</div>
<div>2.Correction de certains bugs de lecteurs cloud.</div>`,
          notif_v420: `<div>1.Le multilinguisme ajoute l'allemand et le chinois traditionnel.</div>
<div>2.Amélioration du lecteur cloud Dropbox.</div>
<div>3.Amélioration de la fonction de partage et ajout des actions d'upload et de nouveau dossier sur la page de partage.</div>`,
          notif_v410: `<div>1.Ajout du système de points.</div>
<div>2.Ajout de la fonction d'affichage des erreurs d'historique.</div>
<div>3.Ajout du bouton de nouvelle tentative manuelle en cas d'échec du transfert.</div>
<div>4.Amélioration des fonctions de recherche, partage et progression de transfert.</div>`,
          notif_v400: `<div>1.Ajout de la fonction de synchronisation cloud, y compris la synchronisation unidirectionnelle, bidirectionnelle, etc.</div>
<div>2.Ajout de la prise en charge des lecteurs cloud OneDrive for Business, Dropbox for Business et Egnyte.</div>
<div>3.Amélioration de la fonction de partage.</div>
<div>4.Amélioration de l'interface.</div>
<div>5.Correction des bugs de transfert.</div>`,
          notif_v380: `<div>1.Mise à niveau de la fonction de partage, ajout du partage de dossiers, gestion des partages, enregistrement et transfert de partages.</div>
<div>2.Ajout de l'option « URL d'upload » dans la fonction d'upload.</div>
<div>3.Correction de certains bugs de lecteurs cloud.</div>
<div>4.Suppression du lecteur cloud Copy.</div>`,
          notif_v370: `<div>1.Ajout des lecteurs cloud mega et Evernote.</div>
<div>2.Ajout de la prise en charge de l'aperçu des fichiers texte, tels que txt, html, js.</div>
<div>3.Optimisation des tâches planifiées.</div>
<div>4.Correction du bug de transfert des documents Google entre Google Drives pour garder les types de fichiers cohérents.</div>
<div>5.Amazon S3 prend en charge le transfert d'un fichier unique supérieur à 5 Go.</div>`,
          notif_v360: `<div>1.Ajout du lecteur cloud hubiC.</div>
<div>2.Ajout de la fonction « Essayer sans inscription » pour une expérience rapide.</div>
<div>3.Ajout de la fonction « Aller sur le site officiel » pour certains lecteurs cloud.</div>
<div>4.Correction des bugs de transmission d'OneDrive et Google Drive.</div>`,
          notif_v350: `<div>1.Amélioration de la vitesse de transmission inter-cloud pour les utilisateurs VIP.</div>
<div>2.Ajout de la sauvegarde MySQL et du lecteur cloud Flickr.</div>
<div>3.Correction de certains bugs du transfert planifié.</div>
<div>4.Correction du bug empêchant de lister les fichiers FTP et WebDav.</div>`,
          notif_v340: `<div>1.Ajout de MediaFire à MultCloud.</div>
<div>2.Ajout d'OwnCloud à MultCloud.</div>
<div>3.Modification du transfert de fichiers planifié.</div>`,
          notif_v330: `<div>1.Ajout d'Alfreco à MultCloud.</div>
<div>2.Ajout d'aDrive à MultCloud.</div>
<div>3.Modification de l'exception d'interruption pour la transmission entre différents clouds.</div>`,
          notif_v320: `<div>1.Ajout de l'option « remplacement ».</div>
<div>2.Mise à niveau de l'API OneDrive et suppression de certaines limites.</div>
<div>3.Correction du bug du lecteur cloud Amazon.</div>
<div>4.Optimisation de l'environnement de transmission.</div>`,
          notif_v310: `<div>1.Prise en charge du lecteur cloud Amazon.</div>
<div>2.Prise en charge du remplacement ou de l'ignorance de certains fichiers pendant le transfert.</div>
<div>3.Amélioration du service SFTP : prise en charge de la connexion avec une clé privée.</div>
<div>4.Optimisation de la fonction de transfert.</div>
<div>5.Correction de certains bugs de lecteurs cloud.</div>`,
          notif_v300: `<div>1.Ajout de nouvelles fonctions telles que le transfert et le gestionnaire de tâches.</div>
<div>2.Prise en charge du réglage du transfert planifié et du filtre de fichiers.</div>
<div>3.Prise en charge de la notification automatique par e-mail après le transfert.</div>
<div>4.Prise en charge de la réédition des comptes et de l'affichage des propriétés des lecteurs cloud.</div>
<div>5.Ajustement et optimisation de certaines interfaces.</div>
<div>6.Amélioration de la stabilité et de la vitesse du transfert en optimisant l'environnement réseau.</div>
<div>7.Correction de certains bugs.</div>`,
          notif_v231: `<div>1.Suppression du bouton « arrière-plan », toutes les tâches de transmission seront définies en arrière-plan par défaut.</div>
<div>2.Correction de certains bugs.</div>`,
          notif_v230: `<div>1.Ajout de la fonction de transmission en arrière-plan.</div>
<div>2.Amélioration de la capacité de transmission.</div>
<div>3.Ajout de la fonction d'affichage des tailles des lecteurs cloud.</div>`,
          notif_v222: `<div>1.Ajout de la fonction d'affichage d'un menu contextuel (clic droit) pour les tablettes et les appareils mobiles.</div>
<div>2.Modification des exceptions concernant l'inscription et la récupération de mot de passe. Vous pouvez également ignorer l'activation pour utiliser MultCloud.</div>
<div>3.Modification de l'exception empêchant d'ajouter une adresse de serveur commençant par http pour WebDav.</div>`,
          notif_v221: `<div>1.Modification des exceptions concernant le listage, la recherche et la copie de fichiers sur Google Drive.</div>`,
          notif_v220: `<div>1.Modification des exceptions de transmission en masse pour une meilleure stabilité de transmission.</div>
<div>2.Ajout de la fonction d'analyse des détails de la progression de la transmission.</div>`,
          notif_v210: `<div>1.Modification du problème d'affichage incomplet des listes de fichiers.</div>
<div>2.Modification des exceptions concernant l'upload, le téléchargement et la transmission de fichiers via FTP.</div>
<div>3.Modification de l'exception d'interruption pour la transmission entre différents clouds.</div>
<div>4.Modification de l'interface d'ajout de FTP et WebDav.</div>
<div>5.Ajout de notes pour chaque lecteur cloud.</div>`,
          notif_v200: `<div>1.Ajout de FTP à MultCloud.</div>
<div>2.Ajout de WebDav à MultCloud.</div>
<div>3.Ajout de l'option de menu : « Copier vers ».</div>
<div>4.Connexion avec les comptes Google et Facebook.</div>
<div>5.Amélioration de l'interface utilisateur pour plus de facilité d'utilisation.</div>
<div>6.Quelques corrections de bugs.</div>
<div>7.Prise en charge de Cubby, MyDrive, Web.de, Yandex, CloudMe, HiDrive, Copy et BaiDu.</div>`,
          applicationKey: 'Clé d\'application',
          keyID: 'ID de clé',
          privateKey: 'Fichier de clé privée pour l\'authentification (facultatif)',
           privateKey2: 'Clé privée',
            //2020-10-26-ljm增加
          progressBox:'Progrès',
          FTPTips:`1. Assurez-vous que vous avez des autorisations de lecture et décriture, sinon, MultCloud ne peut pas transférer de fichiers vers votre FTP.
          2. Assurez-vous quil y ait suffisamment despace pour vos opérations. Nous sommes temporairement incapables didentifier sa taille.`,
          specialDropBox:`Si vous êtes un administrateur Dropbox Business et que vous souhaitez accéder à tous les comptes de votre organisation, veuillez cliquer sur "Accéder à l'organisation" .`,
          specialDropBoxBottom:`Si vous souhaitez accéder à votre cloud personnel, veuillez cliquer sur "Accéder au cloud personnel".`,
          accessOrganization:'Accéder à l\'organisation',
          accessPersonalCloud:'Accéder au cloud personnel',
          specialBoxBusiness:`Si vous êtes un administrateur d'box for Business et que vous souhaitez accéder à tous les comptes de votre organisation, veuillez cliquer sur « Accéder à l'organisation ».`,
          specialgSuite:`Si vous êtes un <a href='https://support.google.com/a/answer/2405986?hl=fr' target="_blank" class='add-cloud-link'> administrateur Google?Workspace </a> et souhaitez accéder à tous les comptes de votre organisation, veuillez "Admin Install" notre Application Google Workspace Marketplace --- "<a href="https://gsuite.google.com/marketplace/app/cloud_transfer_multcloud/72136911391?hl=fr" target="_blank " class='add-cloud-link'>Cloud Transfer – MultCloud</a>" en premier. Et puis cliquez sur "Accéder à l'organisation".`,
          googleWorkspaceGuideIntro: `Si vous êtes <a href="https://support.google.com/a/answer/2405986?hl=fr" target="_blank" class="add-cloud-link">administrateur Google Workspace</a> et souhaitez accéder à tous les comptes de votre organisation, veuillez procéder comme suit :`,
          googleWorkspaceGuideStep1: `Étape 1. Accédez à la <a href="https://admin.google.com/" target="_blank" class="add-cloud-link">console d'administration</a>. Dans le panneau de droite, cliquez sur « Sécurité », puis accédez à « Contrôle des accès et des données » &gt; « Contrôles d'API » &gt; « GÉRER LA DÉLÉGATION À L'ÉCHELLE DU DOMAINE ».`,
          googleWorkspaceGuidePersonal: `Si vous souhaitez accéder à votre cloud personnel, cliquez sur « Accéder au cloud personnel ».`,
          googleWorkspaceGuideStep2: `Étape 2. Cliquez sur « Ajouter ». Dans la fenêtre contextuelle, saisissez les informations suivantes, puis cliquez sur « Autoriser ».`,
          googleWorkspaceGuideStep3: `Étape 3. Cliquez sur « Accéder à l’organisation », connectez-vous avec votre compte administrateur et autorisez MultCloud à accéder à votre organisation.`,
          googleWorkspaceGuideClientId: 'ID client',
          googleWorkspaceGuideScopes1: `Champs d'application OAuth 1`,
          googleWorkspaceGuideScopes2: `Champs d'application OAuth 2`,
          googleWorkspaceGuideViewImage: 'Afficher la capture d’écran en taille réelle',
          googleWorkspaceGuideImageAlt: 'Capture d’écran de configuration Google Workspace, étape {step}',
          specialOnedrive:`Si vous êtes un administrateur d'OneDrive for Business et que vous souhaitez accéder à tous les comptes de votre organisation, veuillez cliquer sur « Accéder à l'organisation ».`,
          iCloudPhotosTips:'MultCloud ne prend pas en charge la connexion à l\'identifiant Apple sans e-mail pour le moment.',
          appleId: 'Identifiant Apple',
        addICloudPhotos: 'Ajouter Photos iCloud',
        addICloudDrive: 'Ajouter iCloud Drive',
        fourShared: `Remarque : l'autorisation 4shared est valable<span style="color: red"> 2 heures. </span> Veuillez rajouter 4shared et exécuter vos tâches manuellement après l'expiration.`,
        fourSharedTips: `Remarque : l'autorisation 4shared est valable 2 heures. Veuillez rajouter 4shared et exécuter vos tâches manuellement après l'expiration.`,
      },
      cloudExploerPopup: {
        googlePhotosV2Tips: 'Astuces pour Google Photos',
        googlePhotosV2TipsDesc: 'Google a mis à jour l\'API Google Photos le 7 mai 2025. Pour intégrer ces changements, nous devons implémenter les mises à jour suivantes :',
        googlePhotosV2Tips1: 'Le dossier « Albums » n\'affichera désormais que les albums créés par MultCloud.',
        googlePhotosV2Tips2: 'Le dossier « Photos » n\'affichera désormais que les images téléchargées via MultCloud.',
        googlePhotosV2Tips3: 'Pour transférer des images de Google Photos vers d\'autres services Cloud, cliquez sur le bouton « Ajouter d\'autres Photos » et accordez à MultCloud l\'accès aux images que vous souhaitez transférer.',
        googlePhotosV2Tips4: 'Pour transférer des images d\'autres services Cloud vers Google Photos, veuillez noter que seuls des dossiers peuvent être transférés vers le dossier « Albums » et que seules des images individuelles peuvent être transférées vers le dossier « Photos ».',
        googlePhotosV2TipsShow: 'Ne plus afficher',
        googlePhotosV2AddMore: 'Ajouter d\'autres Photos',
        googlePhotosV2AddMoreTips: 'Cliquez ici pour ajouter les images que vous souhaitez ajouter à MultCloud.',
        googlePhotosV2FolderName: 'Nom du dossier',
        googlePhotosV2FolderNameInput: 'Saisissez un nom pour le dossier où les images seront enregistrées.',
        googlePhotosV2NotSelect: 'Vous n\'avez pas encore ajouté de photo. Cliquez sur « Ajouter d\'autres Photos » pour ajouter des images à MultCloud.',
        googlePhotosV2SelectAlbums: 'Vous ne pouvez enregistrer des dossiers que dans « Albums ».',
        googlePhotosV2SelectAlbum: 'Vous ne pouvez enregistrer que des images et des vidéos dans ce dossier.',
        googlePhotosV2SelectPhotos: 'Vous ne pouvez enregistrer que des images et des vidéos dans « Photos ».',
        googlePhotosV2SelectSession: 'Ce dossier ne peut pas être sélectionné comme destination. Veuillez plutôt sélectionner le dossier « Albums » ou « Photos ».',
        deleteContentEver: 'Voulez-vous vraiment supprimer définitivement les éléments sélectionnés ?<br>Une fois supprimé, il ne peut pas être restauré à partir de la corbeille.',
        deleteContent: 'êtes-vous sûr de vouloir supprimer les éléments sélectionnés ?',
        deleteConfirm: 'Confirmer la suppression du fichier ?',
        removeSiteTitle: 'Supprimer le site',
        removeSiteConfirm: 'Êtes-vous sûr de vouloir supprimer ce site ?',
        deleteAction: 'Cette action est irréversible. Le fichier sera définitivement supprimé.',
        deleteDeletion: 'Veuillez saisir le nom du fichier pour confirmer la suppression :',
        deleteDeletionOK: 'Veuillez saisir le nom de fichier correct pour confirmer la suppression',
          detailedProgress: 'Progrès détaillés',
          highSpeed: 'La recherche rapide prend en charge les lecteurs cloud suivants',
          takeMoreTime: 'Cela peut prendre plus de temps avec les lecteurs cloud suivants',
          enterKeyWord: 'Entrez le mot clé',
          highSpeedSearch: 'Recherche rapide',
          normalSearch: 'Recherche normale',
          shareWithOthers: 'Partager avec les autres',
          inviteByEmail: 'Inviter des amis par e-mail',
          pleaseEnterEmail: 'Veuillez saisir des e-mails et les séparer par des virgules',
          addMessage: 'Ajouter un message(facultatif)',
          shareTo: 'Partager sur',
          noLink: 'Aucun lien créé pour le moment',
          createShare: 'Créer un partage',
          cancelAllTask: 'Êtes-vous sûr de vouloir annuler toutes les tâches?',
          //2020/8/7-xth
          shareEmailTitle: 'Envoyer le lien par e-mail',
          shareNotSupportSource: 'Ce service cloud ne prend pas en charge cette fonctionnalité, veuillez essayer une autre option de partage',
          shareSendEmail: 'Envoyer un e-mail',
          generateLinkSuccess: 'Lien de partage créé',
          generateLinkFail: 'Impossible de créer un lien de partage',
          emailSentSuccessful: 'E-mails envoyés',
          emailSentNull: 'Vous n\'avez pas saisi d\'e-mail',
          emailSentNotice: 'Veuillez entrer un e-mail correct',
          linkCopySuccessful: 'Lien copié !',
          sharePrivateLink: 'Lien de partage privé : ',
          sharePrivatePassword: ' Afficher le mot de passe : ',
          cancelMyShareTask: 'Êtes-vous sûr d\'annuler le partage? Ce lien ne fonctionnera plus pour quiconque l\'a.',
          cancelMyShareOk: 'Oui, annulez-le',
          cancelMyShareNot: 'Non, je le garde',
          emailArrayToLong50: 'Vous pouvez envoyer 50 e-mails à la fois.',
          shareOnEmail: 'Envoyer le lien par e-mail',
          shareOnFacebook: 'Partager sur Facebook',
          shareOnTwitter: 'Partager sur Twitter',
          shareOnTumblr: 'Partager sur Tumblr',
          shareOnPinterest: 'Partager sur Pinterest',
          shareOnLinkedIn: 'Partager sur LinkedIn',
          ceateShareError: 'Échec de la création du partage, veuillez vérifier votre réseau.'
      },
      cloudTransferPopup: {
          pleaSelect: 'Veuillez sélectionner',
          schedule: 'Planifier',
          checkScheduled: 'Veuillez cocher la case \'Planifier\'de cette tâche pour activer l\'éditeur de planification.',
          addValidCloud: 'Vous devez ajouter un lecteur cloud valide',
           //2020-10-26-ljm增加
          cleanList:'Nettoyer la liste',
      },
      personalCenter: {
          changePassword: 'Changer le mot de passe',
          changeName: 'Changer le nom',
          deleteAccount: 'Supprimer le compte',
          enterPassWord: 'Veuillez saisir votre mot de passe',
          note: 'Remarque : veuillez nous indiquer la raison de votre départ, nous ferons de notre mieux pour le corriger.',
          sureDeleteAccount: 'êtes-vous sûr de vouloir supprimer ce compte ?',
          unsubscribe: 'Avant de supprimer ce compte, veuillez d\'abord vous désinscrire de MultCloud.',
          bindEmail: 'Lier l\'e-mail',
          pleaseSwitch: 'Veuillez passer à MultCloud classique pour décrypter le (s) fichier (s).',
          switchOld: 'Passer au classique',
          pleaseUnsubscribe: 'Veuillez d\'abord passer au MultCloud classique pour vous désabonner du service premium. ',
          deletePremium: 'Vous êtes sur le point de supprimer un compte premium. Une fois supprimé, il ne peut pas être récupéré. Êtes-vous sûr de vouloir supprimer ce compte premium ?'
      },
      remoteTaskPopup: {
          addLinkTask: 'Ajouter une tâche de lien',
          validLink: 'Veuillez saisir un lien valide',
          saveCloud: 'Enregistrer dans le cloud',
          parseFail:"échec de l'analyse",
          inadmissibleRequest:'Une demande non prise en charge',
          createBtTask: 'Créer une tâche BT',
          emptySource: "Veuillez entrer un lien ou télécharger un fichier torrent.",
          validTorrent: "Le fichier torrent sélectionné n'est pas valide.",
          addTorrent: 'Ajouter un torrent',
          tip: 'Sélectionnez un cloud pour stocker le fichier.',
          torrentSelected:'Nom({num}/{all})',
          urlLinkSupported:"Copiez et collez le lien ici, liens http/ https/magnet pris en charge.\nRemarque : N'utilisez pas MultCloud pour télécharger ou téléverser des documents copiés non autorisés.",
          torrentStore:'Veuillez sélectionner un cloud pour stocker le fichier torrent.',
          downloadLink:'Veuillez entrer un lien de téléchargement.',
          cancelTask:'Annuler la tâche',
          cancelTaskContent:'Êtes-vous sûr de vouloir annuler la tâche ? ',
          parseTaskRunning:"MultCloud exécute déjà un processus d'analyse, veuillez vous rendre sur « Téléchargement hors ligne » pour le vérifier."

      },
      taskListPopup: {
          deleteTask: 'Supprimer la tache',
          pleaseSelect: 'Veuillez sélectionner les données avant de les supprimer.',
          sureDeleteTask: 'êtes-vous sûr de vouloir supprimer les taches ?',
          deleteSingleTask: 'êtes-vous sûr de vouloir supprimer la tache ?',
          viewLogs: 'Afficher les journaux',
          selectCloud: ' Veuillez sélectionner le cloud pour enregistrer les fichiers'
      },
      upgradeAccountPopup: {
          commonTitle: '5 tâches cloud-à-cloud en parallèle',
        commonDes: 'Veuillez passer au statut d\'abonné et vous pourrez exécuter 5 tâches cloud-à-cloud en parallèle.',
        upgradeAccount: 'Mettre à niveau le compte',
          upgradeHeadTitle:'5 liens parallèles ou torrents',
          upgradeHeadContent:"Les utilisateurs gratuits peuvent avoir 1 lien de transfert ou une tâche torrent à la fois. Veuillez passer à l'abonné, vous aurez 5 liens de transfert ou tâches torrent à la fois.",
          currentPlan: 'Plan Actuel',
          insufficientTraffic: 'Trafic cloud-à-cloud insuffisant',
          insufficientTrafficDes: 'Vous avez consommé tout le trafic de données gratuit de ce mois. Pour obtenir plus de trafic, veuillez passer à la version premium.',
          filter: 'Filtrage de fichiers',
          filterDes: 'Pour activer le transfert de fichiers/filtre de synchronisation, veuillez passer à la version premium.',
          offlineFree:"1 lien ou torrent à la fois",
          offlinePremium:'5 liens parallèles ou torrents',
          modes: 'Modes de synchronisation avancés',
          modesDes: 'Les abonnés ont la synchronisation bidirectionnelle et 7 options personnalisées dans la synchronisation unidirectionnelle. Prise en charge de la synchronisation de sauvegarde incrémentielle.',
          doubleRealTime:'Double synchronisation en temps réel',
          doubleRealTimeSyncDes:'Mettez à jour l\'abonné et effectuez deux tâches de synchronisation en temps réel simultanément.',
          doubledSync: 'Double synchronisation normale',
          doubleSyncDes: 'Mettez à jour l\'abonné et effectuez deux tâches normales simultanément.',
          realTimeSyncing:'Double Synchronisation En Temps Réel',
          norMalSyncing:'Double Synchronisation Normale',
          free: 'Gratuit',
          premium: 'Premium',
          monthTraffic: '5 Go de trafic/mois',
          syncMode: '2 modes de synchronisation',
          scheduled: 'Transfert/Synchronisation/Sauvegarde planifié',
          scheduledDes: 'Pour activer la fonction de planification, veuillez passer à la version premium.',
          moreTraffic: 'Plus de trafic de données selon vos besoins',
          moreSyncModes: '8 modes de synchronisation',
          transferSpeed: 'Vitesse de transfert quintuplée',
          doubleSync: 'Double-Syncing',
          transferServer: 'Serveur de transfert VIP',
          customerSupport: 'Assistance client VIP',
          syncSupported: 'Synchronisation bidirectionnelle et 7 options personnalisées dans la synchronisation unidirectionnelle. Prise en charge de la synchronisation miroir.',
          greatlyIncreased: 'Il y a 10 threads pour les abonnés au lieu de deux, donc la vitesse de transfert est considérablement augmentée.',
          sameTime: 'Les abonnés peuvent avoir 2 tâches de synchronisation en temps réel et 2 tâches de synchronisation normales (4 au total) exécutées simultanément.',
          normalSametime:'Les abonnés peuvent exécuter deux tâches de synchronisation normales en même temps.',
          automatically: 'Configurez un filtre pour transférer ou synchroniser automatiquement les fichiers avec le nom de fichier défini par l\'utilisateur ou certaines extensions.',
          multipleSync: 'Cibles de synchronisation multiples',
          multipleSyncDes: 'Veuillez passer à la l\'édition payante pour activer la fonction de cibles de synchronisation multiples.',
          freeDes:'Les utilisateurs gratuits ont 30 Go de trafic au total pour transférer ou synchroniser des données entre les services cloud chaque mois.',
          task1: '1 tâche cloud-à-cloud à la fois',
          task5: '5 tâches cloud-à-cloud en parallèle',
          emailTitle: 'Conversions d\'e-mail insuffisantes',
          emailDes: 'Les utilisateurs gratuits bénéficient de 50 conversions d\'emails par mois, mais il semble que vous ayez besoin de plus que cela. Passez à la version premium et vous aurez un nombre illimité de conversions d\'e-mail.',
          emailsConversions: '50 conversions d\'e-mails/mois',
          emailsUn: 'Nombre illimité de conversions d\'e-mails',
      },
      remindBindEmail:{
          bindExe:'Veuillez lier votre e-mail pour exécuter la tâche',
          onceBind:'Une fois lié votre e-mail, vous pouvez obtenir <span class="gift-flow">30 Go</span> de trafic de données cloud-cloud supplémentaire!',
          bindEmail:'Veuillez attacher votre e-mail pour activer les fonctionnalités principales de MultCloud.',
          coreFeatures:'Fonctionnalités principales de Multcloud',
          tourAccount:'Compte visiteur',
          connectCloud:'Connecter les services cloud à MultCloud',
          viewCloud:'Afficher tous les fichiers cloud via MultCloud',
          uploadFile:'Uploader des fichiers vers les clouds ​​via MultCloud',
          downloadCloud:'Télécharger les fichiers Cloud via MultCloud',
          syncAndBackup:'Synchroniser et sauvegarder des fichiers entre les clouds',
          transferFiles:'Transférer des fichiers d\'un cloud à un autre',
          failed:'Échec de l\'exécution de l\'opération, veuillez réessayer plus tard.'
      },
      salePagePopup:{
          sOffer:'Offre spéciale pour MENSUELLEMENT ILLIMITE',
          timeLimited:'Allez, le temps est limité !',
          Hours:'Heures',
          Minutes:'Minutes',
          Seconds:'Secondes',
          monthPrice:'$19.9/mois',
          dataTra:'pour le trafic de données ILLIMITÉ',
          subscribe:'Abonnez-vous maintenant',
          features:'Caractéristiques',
          freePlan:'Offre spéciale',
          bigSale:'Grande offre à durée limitée',
          discountsto:'Remises jusqu\'à',
          off:'25% Réduction',
          premiumPlan:'Édition payante',
          transmit:'Trafic de transfert',
          dataTraffic:'Le trafic de données est pour le transfert et la synchronisation de fichiers entre les clouds.',
          originalPrice:'Prix d\'origine',
          nowOnly:'Maintenant',
          getDiscount:'Obtenir une réduction',
          moreData:'Plus de trafic de données',
          unlimitedData:'Trafic de données illimité',
          syncModes:'Modes de synchronisation',
          syncModesDes:'Les abonnés disposent de la synchronisation bidirectionnelle et de 7 options personnalisées en synchronisation unidirectionnelle. Synchronisation miroir prise en charge.',
          scheduledTran:'Planification de transfert',
          scheduledTranDes:'Avec cette fonctionnalité, vous pouvez planifier une tâche automatique de Cloud à Cloud à intervalle régulier ou à moment spécié.',
          transferSpeedDes:'Il y a 10 threads de transfert pour les abonnés au lieu de 2, la vitesse de transfert est donc considérablement augmentée.',
          fileEncryption:'Cryptage de fichiers',
          encryptFiles:'Les abonnés peuvent crypter en ligne les fichiers téléversés et les fichiers dans les cloud.',
          quarterly:'Trimestriel',
          yearly:'Annuel',
          monthGb:'150 Go/mois',
          monthGbly:'200 Go/mois',
          monthfourLy:'400 Go/mois',
          unTr:'Trafic illimité',
          nMonth:'/mois',
          tQuarter:'/Quarter',
          eYear:'/Année',
          tOneTime:'Unique',
           //2021-10-09
           premiumFeatures:'150 Go de trafic avec toutes les fonctionnalités avancées pendant un mois ！',
           unlimitedYear:'Trafic illimité avec toutes les  fonctionnalités avancées pendant un an ！',
           unlimitedLiftime:'Trafic illimité avec toutes les fonctionnalités avancées à vie ！',
      },
      giveawayActiveSucPopup: {
        headerTitle: "Rédemption réussie!",
        headerSubtitle: "Votre abonnement Premium de 3 mois est activé ! Débloquez la version Illimité à vie avec une offre exclusive de réduction de 80 %.",
        headerSubtitleYear: "Votre abonnement Premium de 1 an est activé ! Débloquez la version Illimité à vie avec une offre exclusive de réduction de 80 %.",
        currentPlanBadge: "Activé",
        currentPlanName: "Premium de 3 mois",
        currentPlanNameYear: "Premium de 1 an",
        currentPlanPrice: "39,99 €",
        feature1: "3 mois de fonctionnalités Premium",
        feature1Year: "1 an de fonctionnalités Premium",
        feature2: "{traffic} Trafic de données pendant 3 mois",
        feature2Year: "{traffic} Trafic de données pendant 1 an",
        feature3: "Assistance clientèle en jours ouvrables",
        upgradePlanBadge: "80% OFF",
        upgradePlanName: "Premium Illimité à vie",
        upgradePlanOriginalPrice: "628 €",
        upgradePlanCurrentPrice: "125.6",
        featureUpgrade1: "Fonctionnalités Premium <b>À vie</b>",
        featureUpgrade2: "Trafic de données <b>Illimité</b>",
        featureUpgrade3: "Assistance VIP prioritaire <b>24h/24 et 7j/7</b> ",
        featureUpgrade4: "Garantie de remboursement de <b>90 jours</b>",
        countdownLabel: "Offre exclusive de mise à niveau se termine dans :",
        btnUpgrade: "Mettre à niveau & Économiser 80%",
        promoText: "Pour obtenir la version Illimité à vie",
        off: "OFF",
      },
      properties: 'Propriétés',
      general: 'Général',
      tips: 'Conseils',
      progress: 'Progrès',
      limits: 'Limites de Cloud',
      detailed: 'détaillé',
      cancel: 'Annuler tout',
      simpleSync: 'Sync simple',
      onewaySync: 'Sync unidirectionnelle',
      twowaySync: 'Sync bidirectionnelle',
      advancedSync: 'Modes de Sync Avancés',
      mirrorSync: 'Sync en mirror',
      moveSync: 'Move Sync',
      cmuSync: 'Sync cumulative',
      updateSync: 'Sync des mises à jour',
      increSync: 'Sync Incrémentielle',
      fullSync: 'Sync de Sauvegarde Complète',
      simpleSyncTip: 'Les fichiers ajoutés, modifiés et supprimés dans le répertoire source seront répliqués dans le répertoire cible. Cependant, les fichiers ajoutés, modifiés et supprimés dans le répertoire cible ne seront pas répliqués dans le répertoire source.',
      mirrorSyncTip: 'Les fichiers des répertoires source et cible sont toujours les mêmes (MultCloud supprimera les fichiers supplémentaires du répertoire cible).',
      moveSyncTip: 'Une fois la synchronisation terminée, tous les fichiers du répertoire source seront supprimés.',
      cmuSyncTip: 'Lors de la suppression des fichiers du répertoire source, les mêmes fichiers du répertoire cible ne seront pas supprimés.',
      updateSyncTip: 'Tous les fichiers du répertoire cible seront supprimés en premier, puis les fichiers ajoutés et modifiés dans le répertoire source seront transférés dans le répertoire cible.',
      increSyncTip: 'Chaque fois que vous synchronisez des fichiers, un sous-répertoire est créé dans le répertoire cible afin que les fichiers ajoutés et modifiés dans le répertoire source lui soient transférés.',
      fullSyncTip: 'Chaque fois que vous synchronisez des fichiers, un sous-répertoire est créé dans le répertoire cible afin que tous les fichiers du répertoire source lui soient transférés.',
      twowaySyncTip: 'Les fichiers ajoutés, modifiés et supprimés dans le répertoire source seront répliqués dans le répertoire cible. De même, les fichiers ajoutés, modifiés et supprimés dans le répertoire cible seront répliqués dans le répertoire source (à savoir, les fichiers dans les répertoires source et cible sont toujours les mêmes).',
      clone: 'Cloner',
      syncModes: 'Modes de Sync',
      email: 'Email',
      filter: 'Filtre',
      thread: 'Thread',
      listThread: 'Nombre de threads parcourus',
      runThread: 'Nombre de threads exécutés',
      sameName: 'Même nom',
      filterInclude: 'Extensions incluses (par ex. png, doc, mp4)',
      filterExclude: 'Noms de fichiers exclus (par ex. target, dist, build)',
      newFilterTag: 'Nouveau tag',
      createTaskStatus: 'Créé',
      pendingTaskStatus: 'En attente',
      runningTaskStatus: 'En cours d’exécution',
      cancelledTaskStatus: 'Annulé',
      completedTaskStatus: 'Succès',
      failedTaskStatus: 'Échoué',
      warnTaskStatus: 'Avertissement',
      errorTaskStatus: 'Erreur',
      warning: 'Avertissement',
      logs: 'Journal',
      once: 'Une fois',
      daily: 'Quoitidien',
      weekly: 'Hebdomadaire',
      monthly: 'Mensuel',
      onlyOnce: 'Exécuter une seule fois lors de :',
      everyDay: 'Exécuter chaque jour lors de :',
      everyWeek: 'Chaque semaine le :',
      at: 'à :',
      sunday: 'Dimanche',
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
      runAt: 'Exécuter le :',
      lastDay: 'Dernier jour',
      chooseAction: 'Si le fichier cible existe déjà. Veuillez choisir une action :',
      optionsPrompt: 'Si les fichiers du cloud source ont un caractère spécial dans le nom de fichier qui n\'est pas autorisé dans le cloud cible,les fichiers seront renommés automatiquement pendant le processus de transfert et un fichier log.html sera créé dans le répertoire racine sur la cible Cloud Drive.',
      sourceNewer: 'Remplacer si la source est plus récente.',
      diffSize: 'Remplacer si taille différente.',
      sourceAll: 'Remplacer si taille différente ou source plus récente.',
      skipFile: 'Ignorer le fichier.',
      skipEmail: 'Ignorer l\'e-mail.',
      overWrite: 'Toujours remplacer.',
      rename: 'Renommer',
      overWriteSourceNewer: 'Remplacer s\'il y a une mise à jour de l\'e-mail d\'origine. ',
      deleteAllSource: 'Supprimer tous les fichiers source une fois le transfert terminé.',
      keepFileDate: `Conserver la date de modification du fichier (prend en charge Dropbox, Google Drive, G Suite).`,
      automaRename: 'Renommer automatiquement les fichiers avec des caractères spéciaux et générer un fichier de script.',
      sendEmail: 'Envoyer une notification par e-mail à la fin de cette tâche.',
      sendMessage: 'Envoyer un message de test',
      ignoreFiles: 'Ignorer les fichiers avec ces extensions',
      includeFiles: 'Inclure uniquement les fichiers avec ces extensions',
      selectSync: 'Vous pouvez sélectionner le mode de synchronisation ici :',
      tipsFor: 'Conseils pour',
      allTasks: 'Toutes les tâches',
      successful: 'Réussi',
      unfinished: 'Inachevé',
      transferDetails: 'Détails du transfert',
      redit: 'Re-edit',
      publicShare: 'Partage publique',
      publicTip: 'Conseils : Toute personne qui obtient le lien peut consulter le fichier',
      privateShare: 'Partage privé',
      privateTip: 'Conseils : Les autres doivent saisir un mot de passe pour afficher le fichier',
      sourceShare: 'Partage source',
      sourceTip: 'Conseils : Créer un lien de partage du lecteur cloud source',
      shareSuccess: 'Réussi à créer un partage',
      copySuccess: 'Copie réussie',
      sharedYet: "Ce fichier a déjà été partagé",
      domain: 'Domaine',
      code: 'Code',
      resendCode: 'Renvoyer le code',
      key: 'Key',
      secret: 'Secret',
        //2020-10-26-ljm增加
      progressBox:'Boîte de progression',
      publicShareEasy: 'N\'importe qui',
      privateShareEasy: 'Privé',
      communityShareEasy: 'Public',
      sourceShareEasy: 'Source',
      reportPopup: {
          title: 'Signaler Partage',
          beforeMsgOne: 'Aidez-nous à comprendre ce qui se passe avec ce partage.',
          beforeMsgTwo: 'Comment le décririez-vous?',
          typeItems: {
              spam: 'Spam',
              malwareVirus: 'Logiciel malveillant ou virus',
              copyrightViolation: 'Violation du droit d\'auteur',
              illegal: 'Contenu illégal',
              notWorking: 'MultCloud ne fonctionne pas correctement',
              other: 'Autre contenu inapproprié',
          },
          nextMsgOne: 'Veuillez remplir les informations relatives à ce signalement.',
          description: 'Description',
          nextMsgTwo: 'Décrivez ce qui se passe avec le partage.',
          yourEmail: 'Votre e-mail',
          nextMsgThree: 'Veuillez fournir votre adresse e-mail pour vous contacter si nécessaire.',
          submit: 'Soumettre',
          back: 'Retour',
          next: 'Suivant',
          messageNone: 'Veuillez entrer la description de ce signalement.',
          emailNone: 'Veuillez entrer votre adresse e-mail.',
          success: 'Votre rapport a déjà été envoyé à l\'équipe MultCloud.'
      },
      subAccountPopup:{
          title: "Gestion des sous-comptes",
          titleMax: "Gestion des sous-comptes",
          titleDes:"Veuillez passer au statut d'abonné et vous serez en mesure de créer et de gérer des comptes secondaires.",
          tabNameUser: "Mode utilisateur",
          tabNameItem: "Mode dossier",
          addItemButton: "Attribuer un dossier",
          users: "Utilisateurs",
          folders: "Dossiers",
          read: "Lire",
          write: "Écrire",
          questionTxtRead: "Les utilisateurs de sous-comptes peuvent télécharger, prévisualiser et copier des fichiers sur leurs clouds dans ce dossier.",
          questionTxtWrite: "Les utilisateurs de sous-comptes peuvent créer de nouveaux dossiers, télécharger, supprimer, renommer des fichiers dans ce dossier.",
          userExist:"L'utilisateur existe déjà.",
          userSelf:"Veuillez ne pas ajouter votre compte en tant que sous-compte.",
          quickAssign: "Attribution rapide",
          quickAdd: "Ajout rapide",
          allow: "Autoriser",
          batchAddUserNull: "Il n'y a actuellement aucun utilisateur ajouté.",
          batchAddItemNull: "Il n'y a actuellement aucun dossier ajouté.",
          noUserFromAddItem: "Veuillez d'abord ajouter un utilisateur.",
          noItemFromAddUser: "Veuillez d'abord ajouter un dossier.",
          addUser: {
              title: "Ajouter un utilisateur",
              radioCreate: "Créer un sous-compte",
              radioAdd: "Ajouter un compte MultCloud existant",
              createNamePlaceholder: "Créer un nom d'utilisateur",
              createPasswordPlaceholder: "Créer un mot de passe",
              addNamePlaceholder: "Veuillez saisir le compte MultCloud existant",
              createNameNone: "Merci d'entrer un nom d'utilisateur.",
              createNameMore: "Le nom d'utilisateur doit comporter moins de 20 caractères.",
              createPasswordNone: "Veuillez entrer un mot de passe.",
              createPasswordError: "Veuillez saisir un mot de passe de 8 à 16 caractères.",
              addUserNameNone: "Veuillez saisir un compte MultCloud existant.",
              addUserNone: "Ce compte n'existe pas.",
          },
          addItem: {
              noFolder: "Veuillez sélectionner un dossier.",
              exist: "Vous avez déjà ajouté le dossier.",
          },
          editUser: {
              title: "Éditer le sous-compte",
              namePlaceholder: "Entrer un nom d'utilisateur",
          },
          cancel: {
              titleUser: "Supprimer le sous-compte",
              titleItem: "Supprimer le dossier",
              msgUser: "Etes-vous sûr de supprimer ce compte ?",
              msgItem: "Etes-vous sûr de supprimer ce dossier ?",
          },
          unknownError: "Impossible de trouver le chemin, veuillez vérifier si le chemin existe ou rajouter le cloud.",
      },
      verifyPopup:{
          verifyTitle: "Vérifiez votre identité",
          toRecoveryText: "je n'en ai aucun",
          verifyEmailTitle: "Vérifiez votre e-mail",
          verifyEmailTips: "Nous enverrons un code de vérification à {email}. Pour vérifier qu'il s'agit bien de votre adresse e-mail, saisissez-la ci-dessous.",
          verifyPhoneTitle: "Vérifiez votre numéro de téléphone",
          verifyPhoneTips: "Nous enverrons un code de vérification à {phone}. Pour vérifier qu'il s'agit bien de votre numéro de téléphone, saisissez les 4 derniers chiffres.",
          verifyPhoneText: "Les 4 derniers chiffres du numéro de téléphone",
          sendCodeBtn: "Envoyez le code",
          enterCode: "Entrez le code",
          checkEmailTips: "Si {email} correspond à l'email alternatif sur votre compte, nous vous enverrons un code.",
          checkPhoneTips: "Si {phone} correspond aux 4 derniers chiffres du numéro de téléphone de votre compte, nous vous enverrons un code.",
          askDevice: "Ne plus me demander sur cet appareil",
          verify: "Vérifier",
          recoveryTitile: "Avez-vous un code de récupération de compte ?",
          recoveryTipsOne: "Si vous avez un code de récupération, entrez-le maintenant. Si vous n'en avez pas, veuillez contacter",
          recoveryTipsTwo: "Votre code de récupération comporte 25 caractères et ressemble à ceci : XXXXX-XXXXX-XXXXX-XXXXX-XXXXX.",
          recoveryCode: "Code de récupération",
          recoveryCodeBtn: "Utilisez le code de récupération",
          recoveryChangeTitile: "De quelle autre manière pouvons-nous vérifier votre identité ?",
          recoveryEmailChange: "Ajouter une autre adresse e-mail",
          recoveryPhoneChange: "Ajouter un numéro de téléphone",
          enterEmail: "Entrez votre adresse e-mail",
          recoveryNextTitle: "Veuillez entrer le code que nous envoyons à {checkCode}.",
          recoveryTipsTitle: "Pour votre protection, le remplacement de vos informations de sécurité prend 30 jours !",
          recoveryTips1: "Comme vous avez activé la vérification en deux étapes, vous devez disposer d'informations de sécurité à jour pour vous connecter à votre compte.",
          recoveryTips2: "Pendant la période d'attente, vous ne pourrez pas vous connecter aux sites ou aux services avec votre compte, mais vous pourrez vous connecter aux appareils.",
          recoveryTips3: "Vous pouvez éviter l'attente :",
          recoveryTips4: "Utiliser un appareil de confiance.",
          recoveryTips5: "Si vous avez un appareil qui ne nécessite pas de codes, utilisez-le maintenant et mettez à jour vos informations de sécurité.",
          recoveryTips6: "Trouver vos informations de sécurité.",
          recoveryTips7: "Y a-t-il une chance qu'il ne soit pas entièrement perdu ? Si vous pouvez le trouver, utilisez-le maintenant pour réactiver votre compte.",
          recoveryTips8: "L'attente rend plus difficile pour quelqu'un d'autre de prendre le contrôle de votre compte avec un mot de passe volé.",
          recoveryPendTitle: "La modification de vos informations de sécurité est toujours en attente",
          recoveryPendTips1: "Sur {data}, vous avez demandé le remplacement de vos informations de sécurité",
          recoveryPendTips2: "Informations de sécurité actuelles",
          recoveryPendTips3: "E-mail secondaire:",
          recoveryPendTips4: "Numéro de téléphone:",
          recoveryPendTips5: "Nouvelles informations de sécurité",
          recoveryPendTips6: "Si vous souhaitez conserver vos informations de sécurité actuelles,",
          recoveryPendTips7: "annuler cette demande.",
          recoveryCancelTitle: "Voici votre nouveau code de récupération",
          recoveryCancelTips1: "Pour sécuriser votre compte, vous avez besoin d'un nouveau code de récupération.",
          recoveryCancelTips2: "Si vous avez besoin de récupérer l'accès à votre compte, ce code vous aidera. Vous devez l'écrire et le conserver dans un endroit sûr. Nous vous recommandons fortement de ne pas stocker votre code de récupération sur un appareil.",
          recoveryCancelTips3: "Si vous aviez auparavant un code de récupération, il n'est plus valide. Utilisez plutôt ce nouveau code.",
          recoveryCancelTips4: "Votre nouveau code est :",
          recoveryCancelSucTitle: "Bon! Revenons à votre compte !",
          recoveryCancelSucTips1: "La mise à jour des informations de sécurité pour {old} a été annulée et vous disposez désormais d'un accès complet à votre compte.",
          recoveryCancelSucTips2: "Les informations de contact utilisées pour démarrer le processus ({new}) ont été supprimées et ne seront pas utilisées comme informations de sécurité pour votre compte.",
          recoveryCancelSucTips3: "Cliquez sur \"Next\" pour revenir à ce que vous étiez en train de faire.",
          recoveryCancelErrorTitle: "Soumettre la demande",
          recoveryCancelErrorTips: "Votre compte est toujours en période d'attente.",
          codeText: "Entrez votre numéro de téléphone",
          exception: {
              emailTwoStringError: "L'email correct commence par \"{errorCode}\".",
              validEmail: "Veuillez saisir un e-mail correct.",
              phoneLastTwoStringError: "Le nombre correct se termine par {errorCode}.",
              validPhone: "Vous devez entrer les 4 derniers chiffres du numéro de téléphone.",
              verificationCodeExpired: "Le code de vérification a expiré.",
              verificationCodeError: "Le code de vérification est incorrect, veuillez vérifier le code et réessayer.",
              verificationRecoveryCodeExpired: "Le code n'a pas fonctionné, veuillez vérifier le code et réessayer.",
              verificationCodeNull: "veuillez entrer le code de vérification",
          }
      },
      worldBackupPopup: {
          // title:'World Backup Day',
          title:'Offre spécial MultCloud',
          titleTip:'Vente Flash 24 heures',
          timerTitle:'L\'offre à durée limitée prendra fin dans ...',
          getOffer:'Obtenir l\'offre',
          tips100Mo:'100 Go/trafic de données mens.',
          ps100Mo:'Conseils : Le trafic de données inutilisé s\'accumulera. Par exemple : Vous n\'avez consommé que 50 Go sur 100 Go le premier mois, vous aurez encore 50 Go de trafic de données supplémentaire le mois suivant.',
          tips1200Yr:'1200 Go/trafic de données anl.',
          ps1200Yr:'Tips: Le trafic de données inutilisé s\'accumulera. Par exemple : Vous n\'avez consommé que 1000 Go sur 1200 Go la première année, vous aurez encore 200 Go de trafic de données supplémentaire l\'année suivante.',
          tips2400Yr:'2400 Go/trafic de données anl.',
          ps2400Yr:'Tips: Le trafic de données inutilisé s\'accumulera. Par exemple : Vous n\'avez consommé que 2000 Go sur 2400 Go la première année, vous aurez encore 400 Go de trafic de données supplémentaire l\'année suivante.',
          tipsUnYr:'Illimité/trafic de données anl.',
          psUnYr:'Conseils: Trafic de données illimité pendant un an !',
          tipsUnLi:'Illimité/trafic de données à vie',
          psUnLi:'Conseil: Trafic de données illimité à vie !',
          tips1:'10 threads pour le transfert',
          tips2:'Tranfert Cloud planifié',
          tips3:'Support prioritaire 24/7/365',
          ps1:'Il y a 10 threads pour les inscrits, et seulement 2 pour les utilisateurs gratuits, la vitesse de transfert est donc considérablement augmentée.',
          ps2:'Les inscrits peuvent planifier un transfert/synchronisation automatique de Cloud à Cloud à intervalles réguliers ou à un moment précis.',
          moPrice:'{price} / mois',
      },
      iosPayTipPopup: {
        title: 'Annuler l\'abonnement Apple',
        tip: 'Votre abonnement actuel de {name} est en cours de renouvellement automatique (Apple Transaction ID : {id}), veuillez l\'annuler et réessayer.',
        btnTxt: 'Comment annuler',
    },
    appRecommendPopup: {
        title: 'La nouvelle application MultCloud est disponible maintenant !',
        tip: 'Téléchargez immédiatement pour gérer et transférer des <br>données entre les clouds avec des appareils mobiles.',
        modileTitle: 'Obtenez l\'application mobile MultCloud maintenant !',
        iosBtnTitle: 'Télécharger dans',
        iosBtnTip: 'l’App Store',
        androidBtnTitle: 'DISPONIBLE SUR',
        androidBtnTip: 'Google Play',
        apkBtnTitle: 'Télécharger',
        apkBtnTip: 'MultCloud',
    },
    note: 'Note',
    editCloudNoticPopup: {
        tips: 'L\'autorisation a expiré, veuillez ajouter à nouveau le Cloud à MultCloud et réessayer.',
        btnTxt: 'Ajouter à nouveau',
    },
    appleTipsPopup: {
        title: 'Conseils',
        tipTitle: 'Conseils pour l\'authentification à deux facteurs de Photos iCloud',
        tip1: 'Pour connecter vos Photos iCloud à MultCloud, il vous faut autoriser l\'accès au serveur MultCloud à votre identifiant Apple. Ainsi, vous constaterez peut-être que l\'emplacement de notre serveur diffère de votre emplacement réel pendant l\'authentification à deux facteurs.',
        tip2: 'Votre sécurité et votre confidentialité sont notre priorité numéro un. MultCloud ne stocke pas vos données en permanence. Il peut mettre temporairement en cache une partie du contenu en fonction de vos opérations, mais il sera supprimé de notre serveur dès que l\'opération sera terminée. Et la connexion entre vos photos iCloud et les serveurs MultCloud est toujours assurée par un canal SSL 256 bits sécurisé.',
        checkTip: 'Ne montrez plus ça',
    },
    iCloudDriveTips: {
        title: 'Conseils',
        tipTitle: 'Conseils pour l\'authentification à 2 facteurs d\'iCloud Drive',
        tip1: 'Pour connecter votre iCloud Drive à MultCloud, il vous faut autoriser l\'accès au serveur MultCloud à votre identifiant Apple. Il se peut donc que l\'emplacement de notre serveur diffère de votre emplacement réel pendant le processus d\'authentification à deux facteurs.',
        tip2: 'Et n\'oubliez pas : votre sécurité et votre vie privée sont notre priorité numéro 1. MultCloud ne stocke pas les données de manière permanente. Il se peut qu\'il mette temporairement en cache une partie du contenu en fonction de vos opérations, mais il sera immédiatement supprimé de notre serveur une fois l\'opération terminée. La connexion entre votre iCloud Drive et les serveurs de MultCloud se fait toujours via un canal SSL 256 bits sécurisé.',
        checkTip: 'Ne montrez plus ça',
    },
    checkApplePopup: {
        title: 'Identification à deux facteurs',
        tip1: 'Vous avez activé l\'identification à deux facteurs à deux facteurs. Veuillez entrer le code de vérification sur votre iPhone/iPad/iPod pour continuer.',
        tip2: 'Vous n\'avez pas reçu de code de vérification ?',
        btn1: 'Envoyer un message...',
        btn2: 'Envoyer à nouveau le code',
        btn3: 'Envoyez-moi un SMS',
        btn4: 'Obtenir une assistance',
        suc1: 'Un message avec un code de vérification a été envoyé à {num}.',
        suc2: 'Un message contenant un code de vérification a été envoyé à vos appareils.',
        fail1: 'Le code de vérification n\'a pas été envoyé, veuillez réessayer.',
        fail2: 'Veuillez entrer le code de vérification pour continuer.',
    },
    downloadThreadPopup: {
        title: "Télécharger les réglages",
        tips: "Nom du fichier téléchargé",
        defaultNameOne: "Emails saved on {date}",
        defaultName: "{num} emails saved on {date}",
        option1: "Enregistrer les pièces jointes",
        option2: "Format de conversation",
        option2Tips: "Les citations seront supprimées lors de l'activation.",
        option3: "Enregistrer uniquement le dernier message",
    },
    failedFilesPopup: {
        title: 'Afficher les fichiers ayant échoué : {num}',
        exportExcel: 'Exporter vers Excel',
        retrySucTip: '{num} éléments ont été ajoutés à la liste de nouvelles tentatives.',
    },
    viewLogsPopup: {
        title: 'Détails de la tâche :',
        titleRe: 'Détails de la restauration :',
        errorNum: 'Nombre d\'échecs',
        addNum: 'Ajouter des fichiers',
        updateNum: 'Modifier le fichier',
        deleteNum: 'Supprimer le fichier',
        syncSize: 'Taille de la synchronisation',
        syncTime: 'Temps de synchronisation',
        backupNum: 'Nombre de sauvegardes',
        backupSize: 'Taille de la sauvegarde',
        backupTime: 'Temps de sauvegarde',
        restoreNum: 'Nombre de restaurations',
        restoreSize: 'Taille de restauration',
        restoreTime: 'Temps de restauration',
        cloneNum: 'Nombre de clonages',
        cloneSize: 'Taille du clonage',
        cloneTime: 'Temps de clonage',
        tranNum: 'Nombre de transfert',
        tranSize: 'Taille du transfert',
        tranTime: 'Temps de transfert',
        from: 'Source :',
        to: 'Cible :',
        executeTime: 'Temps d\'exécution :',
        sourceAccount:'Compte d\'source',
        targetAccounts:'Compte d\'cible',
        executeResult: 'Résultat d\'exécution',
        add: 'Ajouter :',
        update: 'Mettre à niveau :',
        delete: 'Supprimer :',
    },
    taskProgressPopup: {
        title1: 'Vous êtes un utilisateur premium, vous disposez désormais de 10 threads pour transférer des fichiers simultanément.',
        title2: 'Mettez à niveau vers n\'importe quel service Premium pour avoir un maximum de 10 !',
        btnTip: 'À partir de 9,99 € seulement',
    },
    subfileSelectPopup: {
        title: 'Sélectionnez le contenu à téléverser',
    },
    deleteBatchPopup: {
        tips1: 'Êtes-vous sûr de vouloir supprimer ces <span>{num}</span> tâches ?',
        tips2: 'Une fois supprimées, les tâches ne pourront pas être récupérées.',
    },
    freeSaledPopup: {
        tips1: 'Gardez les souvenirs de votre famille connectés à travers les clouds — obtenez 10 Go GRATUITS pour la Fête de la famille !',
        tips2: 'Attendez !',
        tips3: 'Vous allez laisser passer l\'offre pour la Fête des Pères ? Petit rappel : une fois manquée, elle est perdue !',
        btns1: 'Obtenez 10 Go',
        btns2: 'Non, merci',
        success: 'Félicitations ! Vous venez de recevoir 10 Go de trafic de transfert inter-cloud.',
        floatTitle: '10 GO GRATUITS',
        popupTitle: '<span>10 GO</span> GRATUITS',
    }
  },
  addCloud: {
      connectDesc: 'Sélectionnez un service à connecter.',
      box: 'box',
      boxBusiness:'box for Business',
      dropbox: 'Dropbox',
      google_drive: 'Google Drive',
       google_drive_sharedWithMe: 'Partagé avec moi',
      google_drive_v2: 'Google Drive',
      google_drive_shared_v2: 'Partagé avec moi',
      oneDrive: 'OneDrive',
      oneDriveV2: 'OneDrive',
      sugarSync: 'SugarSync',
      amazonS3: 'Amazon S3',
      iDrivee2: 'IDrive® e2',
      wasabi:'Wasabi',
      webDav: 'WebDAV',
      FTP: 'FTP',
      NAS: 'NAS',
      cloudMe: 'CloudMe',
      cubby: 'Cubby',
      myDrive: 'MyDrive',
      yandex: 'Yandex',
      hiDrive: 'HiDrive',
      WEBDE: 'WEB.DE',
      baiDu: 'BaiDu',
      amazon: 'Amazon',
      alfresco: 'Alfresco',
      aDrive: 'ADrive',
      Icedrive: 'Icedrive',
      oneDrive4Business: 'OneDrive for Business',
      dropbox4Business: 'Dropbox Business',
      pCloud: 'pCloud',
      mega: 'MEGA',
      backblaze: 'Backblaze',
      putio: 'Putio',
      googlePhotos: 'Google Photos',
      googlePhotosV2: 'Google Photos',
      gSuiteSharedDrive: 'Drive partagé',
      evernote: 'Evernote',
      flickr: 'Flickr',
      mediafire: 'MediaFire',
      ownCloud: 'ownCloud',
      mySQL: 'MySQL',
      gSuite: 'Google Workspace',
      hubiC: 'hubiC',
      egnyte: 'Egnyte',
      youtube1: 'youtube1',
      facebook: 'facebook',
      picasa: 'picasa',
      goDaddy: 'goDaddy',
      ubuntu: 'ubuntu',
      welcomeTo: 'Bienvenue dans MultCloud',
      peCloud: 'Services personnels',
      buCloud: 'Services professionnels',
      welcomeFont: 'Maintenant, vous pouvez facilement transférer et gérer vos multiples fichiers cloud avec une seule application. Tout d\'abord,veuillez connecter votre cloud à MultCloud.',
      sharePointOnline:"SharePoint Online",
      iCloudPhotos: 'Photos iCloud',
      gmail: 'Gmail',
      comingSoon: 'À venir...',
      iCloudDrive: 'iCloud Drive',
      signInWith: 'Se connecter avec',
      outlook: 'Outlook',
      fourShared: '4shared',
      google_workspace: 'Google Workspace',
  },
  addEmail: {
    connectDesc: 'Cliquez sur l\'e-mail pour le connecter à MultCloud.',
    peEmail: 'Sélectionnez et connectez-vous avec e-mail',
    iCloudNotice: 'iCloud Drive est temporairement incapable de se connecter et notre équipe de développement s\'efforce actuellement de résoudre le problème.',
    iCloudPhotosNotice: 'iCloud Photos est temporairement incapable de se connecter et notre équipe de développement s\'efforce actuellement de résoudre le problème.',
},
cloudExploer: {
      uploadFile: 'Uploader un fichier',
      newFolder: 'Nouveau dossier',
      newAlbum: 'Nouvel album',
    search: 'Chercher',
      grid: 'Grille',
      pageList: 'Liste',
      reFresh: 'Actualiser',
      modified: 'Modifié sur',
      openWith: 'Ouvrir avec',
      officeOnline: 'Microsoft Office Online',
      loading: 'Veuillez patienter, chargement ...',
      uploadFolder: 'Uploader un dossier',
      trash: 'Corbeille',
      recentlyDeleted: 'Supprimés récemment',
      jumpTo: 'Sauter à',
      deleteForever: 'Supprimer définitivement',
      restore: 'Restaurer',
      back: 'Retour',
      searchResult: 'Résultat de la recherche',
      emptyTrash: 'Vider la corbeille',
      recoverAll: 'Tout récupérer',
      deleteAll: 'Tout supprimer',
      fileExists: 'Le fichier existe',
      chooseOption: 'Le fichier existe, veuillez choisir une option !',
      needRestore: 'Pour afficher ce dossier, vous devrez le restaurer à partir de votre corbeille',
      limitBoxTip: '1.Certains disques cloud peuvent avoir certaines limites. Par exemple, Box ne prend pas en charge la transmission d\'un fichier unique supérieur à 2 Go. Ces limitations sont définies par le fournisseur de cloud et ne peuvent pas être dépassées par MultCloud. Pour plus d\'informations,<a href="https://www.multcloud.com/fr/help/limitations.html" target="_blank" class="add-cloud-link">cliquez ici</a>.<br>2. Si vos tâches n\'ont toujours pas reçu 10 threads après la mise à niveau vers premium, veuillez annuler et retransférer les tâches. Vos tâches recevront 10 threads à transférer avec des serveurs vip exclusifs.',
      fileNameNotEmpty: 'Le nom de fichier que vous avez entré ne peut pas être vide.',
      notContainSpecialChar: 'Le nom de fichier ne peut pas contenir de caractères spéciaux `/ \ | : * ? " < >`.',
      CharacterLimit:'Le nom de fichier ne peut pas contenir de caractères spéciaux `~"# %& *: < >？ / \ { | }.`',
      pathNotExist: 'Le chemin n\'existe pas',
      emptyNotice: 'Ce dossier est vide',
      trashEmpty: 'La corbeille est vide',
      searchEmpty: 'Les résultats de la recherche sont vides',
      tooManyFiles: 'Il y a trop de fichiers, les fichiers précédemment chargés ne seront plus affichés.',
      uploadSize: 'La taille totale d\'une tâche de téléchargement ne peut pas être supérieure à 1 Go.',
      simultaneous: 'Vous pouvez ajouter au maximum 200 tâches simultanément.',
      cancelFailed: 'L\'annulation a échoué, la tâche est en cours de création, veuillez réessayer plus tard',
      taskCanceling: 'La tâche est en cours d\'annulation, veuillez réessayer plus tard',
      notWith: 'Les noms de fichiers et de dossiers ne peuvent pas commencer ou se terminer par "."',
      notUpload: 'le téléchargement a échoué.',
      duplicatePhoto: 'Photo en double. La photo que vous essayez de télécharger est un doublon et n\'a pas été importée dans votre photothèque.',
      dataLoaded: 'Données chargées',
      sharedDate:'Date de partage',
      failedRestore: 'Échec de la restauration du fichier, car le répertoire cible contient un fichier avec le même nom de fichier.',
      //2020-12-11 lijimin
      uploadError:'Ce fichier est interdit de téléchargement (par le service cloud officiel).',
      downloadLimit: 'La limite de téléchargement pour aujourd\'hui a été atteinte. Veuillez réessayer demain.',
      //2022-4-26 wt
      newBucket:'Nouveau compartiment',
      createBucket : 'Le nom du compartiment ne doit contenir que des lettres minuscules et des chiffres. La longueur doit être de 3 à 63 caractères. Note : Le nom du compartiment ne peut pas être composé uniquement de chiffres (par exemple, « 12345678 »).',
      deleteBucket : 'MultCloud ne peut pas supprimer les compartiments avec une convention de nom uniquement en chiffres (c\'est-à-dire « 12345678 »).',
      getBucketObjectListFail : 'MultCloud ne peut pas répertorier un compartiment avec une convention de nom uniquement en chiffres (c\'est-à-dire « 12345678 »).',
      newAlubm: '',
      specialCharError: 'Le nom de fichier ne peut pas contenir de caractères spéciaux `/ | : * ? " < >`.',
      copiedToClipboard: 'Copié dans le presse-papiers',
      inputTitle: 'Titre',
      inputPlaceholder: 'Saisir le contenu',
      pleaseInputContent: 'Veuillez saisir le contenu',
      pleaseEnterBucketName: 'Veuillez saisir le nom du bucket',
      pleaseEnterFolderName: 'Veuillez saisir le nom du dossier',
      pleaseInputNewName: 'Veuillez saisir le nouveau nom',
},
emailExploer: {
    from: 'De',
    to: 'Pour',
    cc: 'cc',
    email: 'E-mails',
    subject: 'Objet',
    received: 'Reçu',
    sentTime: 'Envoyé',
    downloadMax200: 'Sie können höchstens 200 E-Mails gleichzeitig herunterladen.',
    noSubject: '(aucun objet)',
    folderName: {
        Inbox: 'Boîte de réception',
        Starred: 'Messages suivis',
        Snoozed: 'En attente',
        Sent: 'Messages envoyés',
        Drafts: 'Brouillons',
        Important: 'Important',
        Chats: 'Tous les chats',
        Scheduled: 'Planifié',
        AllMail: 'Tous les messages',
        Spam: 'Spam',
        Trash: 'Corbeille',
        Unread: 'Non lus',
        Categories_Social: 'Catégories_Réseaux sociaux',
        Categories_Updates: 'Catégories_Notifications',
        Categories_Forums: 'Catégories_Forums',
        Categories_Promotions: 'Catégories_Promotions',
        Categories_Personal: 'Catégories_Personnel',
    }
},
imageSaver: {
    analyzing: 'En cours d\'analyse',
    failedToParse: 'Échec de l\'analyse',
    noviceGuidance: 'Vous pouvez consulter ici toutes les images/vidéos récemment téléchargées vers le cloud ou les images/vidéos regroupées pour Instagram.',
    insDownloadExist: 'Vous avez déjà téléchargé ce profil. Vous pouvez le retrouver dans la section « Liste des tâches ».',
    taskExpiredOn: 'Expiré le {time}',
    taskStoringTill: 'Enregistrer dans {time}',
    taskPart: 'Partie',
    taskUnitFile: 'fichier',
    taskUnitFiles: 'fichiers',
    taskQueue: 'En attendant',
    taskTabUpload: 'Charger',
    taskTabSaveAll: 'Enregistrer tout dans le cloud',
    taskTabDownload: 'Télécharger tout IG',
    downloadInsVideo: 'Télécharger la vidéo',
    downloadSinglePost: 'Télécharger la publication totale',
    downloadAllPosts: 'Télécharger toutes les publications',
    downloadAllReels: 'Télécharger tous les reels',
    downloadAllStories: 'Télécharger tous les stories',
    downloadAllHighlights: 'Télécharger tous les highlights',
    saveInsVideo: 'Enregistrer la vidéo dans le cloud',
    saveSinglePost: 'Enregistrer la publication total dans le cloud',
    saveAllPosts: 'Enregistrer toutes les publications dans le cloud',
    saveAllReels: 'Enregistrer tous les reels dans le cloud',
    saveAllStories: 'Enregistrer tous les stories dans le cloud',
    saveAllHighlights: 'Enregistrer tous les highlights dans le cloud',
    insCardPosts: 'publications',
    insCardFollowers: 'followers',
    insCardFollowing: 'suivi',
    insTabPosts: 'Photos et Vidéos',
    insTabReels: 'Reels',
    insTabStories: 'Stories',
    insTabHighlights: 'Highlights',
    insBlankText: 'Avec Téléchargeur Instagram de MultCloud, téléchargez et enregistrez sans effort des publications, des Reels, des stories et des highlights d\'Instagram pour gérer votre contenu préféré à tout moment.',
    webGoogleBlankText: 'Collectez sans effort des images à partir de n\'importe quel site Web ou recherche Google et enregistrez-les directement dans votre cloud ou stockage local.',
    noTask: 'Aucune tâche',
    inputTipHttp: 'Entrez l\'URL d\'un site Web ou un mot-clé de recherche Google',
    fetchBtn: 'Obtenir',
    fetchingBtn: 'Récupération en cours...',
    loadMore: 'En savoir plus',
    downloadAll: 'Tout télécharger',
    saveAll: 'Enregistrer tout dans le cloud',
    saveToCloud: 'Enregistrer dans le Cloud',
    clearHistory: 'Effacer l\'historique',
    cancel: 'Annuler',
    retry: 'Réessayer',
    view: 'Voir',
    noImage: 'Aucun contenu trouvé',
    notSupport: 'Il se peut que cette URL ne soit pas prise en charge. Veuillez vérifier l\'URL et réessayer.',
    inputTipIns: 'Entrez un lien Instagram',
    post: 'post',
    posts: 'posts',
    uploadTo: 'Charger vers: ',
    download: 'Télécharger',
    uploading: 'Chargement en cours',
    finished: 'Fini',
    all: 'Tous',
    videoInputTip: 'Collez le lien de votre vidéo ici',
    videoTip: `Téléchargez des vidéos de haute qualité depuis YouTube, Facebook, X et plus de <a href="https://www.multcloud.com/help/video-downloader.html" target="_blank" style="text-decoration: underline;color: #5562B4;">1 000 autres sites</a>
    avec le téléchargeur de vidéos en ligne multiplateforme et sans publicité de MultCloud — aucune installation requise.`,
    process: 'Traitement...',
    thumbnail: 'Vignette',
    abrTypeVeryHigh: 'Très élevée',
    abrTypeHigh: 'Élevée',
    abrTypeNormal: 'Normale',
    abrTypeLow: 'Faible',
    default: 'Défaut',
    generat: 'Génération du fichier',
    retryTip: 'La tâche a été relancée. Vous pouvez consulter les dernières avancées sous l\'onglet « Tous ».',
},
taskList: {
      taskListDes: 'Vous pouvez gérer ici les taches de transfert, de synchronisation du cloud et d\'enregistrement de fichiers partagés ',
      multiCloudSync: 'Synchronisation multi-cloud',
      MultiCloudTransfer: 'Transfert multi-cloud',
      nextTransfer: 'Prochain transfert',
      scheduled: 'Planifié',
      nextSync: 'Synchronisation suivante',
      reTransfer: 'Transférer à nouveau',
      saveNow: 'Sauvegarder maintenant',
      transferTasks: 'Tâches de transfert',
      syncTasks: 'Tâches de synchronisation',
      shareTasks: 'Partager les tâches',
      backupTasks: 'Tâches de Sauvegarde',
      emailTransferTasks: 'Tâches de Migration E-mail',
      allTime: 'Tout le temps',
      today: 'Aujourd\'hui',
      latestWeek: 'Dernière semaine',
      latestMonth: 'Dernier mois',
      customDate: 'Date personnalisée',
      allStatus: 'Tous les États',
      preset: 'Prérégler',
      noTaskCreated: 'Aucune tâche n\'a été créée',
      createTransferTask: 'Créer une tâche de transfert',
      createSyncTask: 'Créer une tâche de synchronisation',
      createRemoteTask: 'Créer une tâche hors ligne',
      timeMustLess: 'L\'heure de début doit être inférieure ou égale à l\'heure de fin',
      taskNameRule: 'Le nom de la tâche ne peut pas dépasser 200 caractères',
      backupTaskNameRule:'Der Aufgabenname darf nicht länger als 255 Zeichen sein',
      detailNote: 'Cette tâche est encore en préparation, aucun détail à montrer.',
      notTraffic: 'Pas assez de trafic de données pour la transmission cloud à cloud',
      reSync:'Re-synchroniser',
      rebackup:'Re-sauvegarde',
      rerestore:'Re-restaurer',
      //2021-10-11
      createBackupTask:'Créer une tâche de sauvegarde',
      createTeamTransferTask:'Créer une tâche de transfert d\'équipe',
      multiClouds: 'Multi-clouds',
    speedUP: 'Accélérer',
    noTasks: 'Aucune Tâche',
    noTasksTip: 'Cliquez sur les boutons ci-dessous pour créer une tâche.',
    startCloudTransfer: 'Démarrer le transfert cloud',
    startCloudSync: 'Démarrer la synchronisation cloud',
    loadingTip: 'Veuillez patienter un instant.',
    allTasks: 'Toutes les tâches ({num})',
  },
  cloudTransfer: {
      transferDescription: 'Configurer une tâche  de transfert pour transférer des fichiers entre des disques cloud',
      transferOperateFrom: 'Cliquez ici pour sélectionner les disques ou dossiers cloud à partir desquels vous souhaitez transférer',
      from:'De',
      to:'à',
      transferOperateTo: 'Cliquez ici pour sélectionner le disque cloud ou le dossier vers lequel vous souhaitez transférer',
      transferNow: 'Transférer maintenant',
      transfer: 'Transférer',
      addTaskOnly: 'Ajouter une tache uniquement',
      addTaskNow: 'Ajouter une tache et transférer maintenant',
      addSyncTaskNow: 'Ajouter une tache et synchroniser maintenant',
      addBackupTaskNow:'Ajouter une tâche et sauvegarder maintenant',
      transferSucces: 'Transfert réussi',
      sureContinue: '1.Vous avez sélectionné plus de 10 éléments sources et chaque élément source correspond à un e-mail de notification. Cela signifie que vous pouvez recevoir plus de 10 e-mails de notification. Êtes-vous sûr de continuer ?',
      sure: 'Oui, je suis sûr.',
      //2020-10-29ljm新增
      sourceRemind:'Le nombre maximum d\'éléments source est de 200. Veuillez sélectionner moins d\'éléments ou sélectionner un dossier entier. P.S. Un dossier entier ne compte qu\'un seul élément.',
      backupSourceRemind:'Le nombre maximum d\'éléments source est de 1000. Veuillez sélectionner moins d\'éléments ou sélectionner un dossier entier. P.S. Un dossier entier ne compte qu\'un seul élément.'
  },
  cloudSync: {
      syncDescription: 'Configurer une tache de synchronisation pour synchroniser les fichiers entre les disques cloud',
      syncOperateTo: 'Cliquez ici pour sélectionner les disques ou dossiers cloud pour synchroniser',
      syncOperateFrom: 'Cliquez ici pour sélectionner le disque cloud ou le dossier à partir duquel vous souhaitez effectuer la synchronisation',
      syncNow: 'Synchroniser maintenant',
      taskEmpty: 'Le nom de la tache ne peut pas être vide.',
       //2020-10-29ljm新增
       aimRemind:'Le nombre maximum de répertoires cibles est de 200.',
       realTimeSync:'Sync en temps réel',
       normalSync:'Sync normale',
       pause:'Pause',
       paused:'En pause',
       swicthTwoWay:'Passer à Sync bidirectionnelle',
       switchOneWay:'Passer à Sync unidirectionnelle',
       fristSync:'Première synchronisation',
       lastSync:'Dernière synchronisation',
      initSync:'La synchronisation initiale des données est toujours en cours, veuillez patienter.',
      realSyncing:'Synchronisation en temps réel...',
      servicesSu:'Services de clouds supporte la synchronisation en temps réel',
      addRealDrives:'Vous devez ajouter un cloud drive qui supporte la synchronisation en temps réel.',
      egDrives:'Pour l\'instant, seuls Google Drive, Dropbox, Dropbox Business, OneDrive, OneDrive for Business, G Suite, box supportent la synchronisation en temps réel.',
      initTial:'Initialisation',
      createdAt:'Créé à',
      oneWaySimple:'Unidirectionnel (synchronisation simple)',
      twoWay:'Bidirectionnel (à venir...)',
      realSync:'Synchronisation en temps réel',
      gooleFolder:'Si seuls les sous-répertoires du dossier Google Drive ont changé, cette synchronisation ne sera pas effectuée.',
      realTimeNotice:'Vous pouvez exécuter jusqu\'à 2 tâches de synchronisation en temps réel en même temps, de sorte que certaines de vos sous-tâches seront suspendues. Êtes-vous sûr de continuer ?',
      selectAlbumWarn:'Remarque : Un album peut uniquement stocker des images, des vidéos et d\'autres fichiers multimédia, mais pas des répertoires.',
      bePaused:'Si la tâche de synchronisation en temps réel ne s\'exécute pas pendant plus de 7 jours, la tâche sera automatiquement suspendue.',
      dontShow:'Ne plus afficher cela',
      timeOut:'La traversée a expiré',
      outMostly:'L\'expiration de la traversée est principalement due au fait qu\'il y a trop de fichiers ou de sous-répertoires à synchroniser en temps réel. Nous vous recommandons plutôt de créer une tâche de synchronisation normale.',
      syncPathConflict: 'La source et la cible ne peuvent pas être le même dossier, et ni l\'un ni l\'autre ne peut être contenu dans l\'autre. Veuillez sélectionner deux dossiers distincts.',
      reachMax:'Vous avez atteint le nombre maximum de journaux, seuls les derniers journaux sont affichés.',
      notRun:'la tâche ne s\'exécute pas.'
  },
  emailTransfer: {
    cloudEmail: 'Migration E-mail',
    description: 'Migrez votre e-mail vers cloud en tant que PDF.',
    migrationSetting: 'Paramètres de migration',
    cutSetting: 'Réglages de coupe',
    copySetting: 'Réglages de copie',
    settingTips: '',
    notification: 'Notification',
    watermark: 'Filigrane',
    delWatermark: 'Supprimer les filigranes des e-mails téléchargés au format PDF',
    saveAtt: 'Enregistrer les pièces jointes',
    converFormat: 'Format de conversation',
    converFormatTip: 'Les citations seront supprimées lors de l\'activation.',
    saveOnly: 'Enregistrer uniquement le dernier message',
    optionTitle: 'Certains e-mails existent déjà, que voudriez-vous faire ?',
    filterTitle: 'Vous pouvez spécifier des filtres supplémentaires pour la sélection DE.',
    filterMessage: 'Veuillez saisir les e-mails et les séparer par une virgule',
    filterOption1: 'La remplacer si la discussion a été mise à jour',
    filterOption2: 'Toujours ignorer',
    filterOption3: 'Toujours renommer',
    filterOption4: 'Contient une pièce jointe',
    filterOption5: 'Non lu',
    transferNow: 'Migrer maintenant',
    filterDateOptions1: 'Indifférente',
    filterDateOptions2: 'Plus d\'une semaine',
    filterDateOptions3: 'Plus d\'un mois',
    filterDateOptions4: 'Plus de six mois',
    filterDateOptions5: 'Plus d\'un an',
    filterDateOptions6: 'Plage personnalisée',
    showMore: 'Afficher plus',
    startDate: 'Date de début',
    endDate: 'Date de fin',
},
  exception: {
      exceedMaxLimit: 'Le nombre de demandes a dépassé le maximum.',
      addCloudFailed: 'Certains paramètres n\'ont pas été saisis correctement',
      cloudNameExist: 'Ce nom d\'affichage existe déjà, veuillez en saisir un autre.',
      pathNotFound: 'Vérifier si un fichier ou un dossier par un chemin donné existe.',
      notBeTheSame: 'Le dossier source et le dossier cible ne peuvent pas être identiques.',
      notTransferring: 'Ce répertoire ne peut pas être sélectionné pour le transfert de fichiers, veuillez sélectionner ses sous-répertoires ou d\'autres répertoires.',
      verifyCodeInvalid: 'Erreur de code de vérification.',
      nameEmpty: 'Le nom d\'affichage ne peut pas être vide',
      emailEmpty: 'L\'e-mail ne peut pas être vide',
      serverEmpty: 'le serveur ne peut pas être vide',
      usernameEmpty: 'Le nom d\'utilisateur ne peut pas être vide',
      passwordEmpty: 'Le mot de passe ne peut pas être vide',
      domainEmpty: 'Le domaine ne peut pas être vide',
      bucketNameEmpty: 'Le nom du compartiment ne peut pas être vide',
      accessKeyEmpty: 'L\'ID de la clé d\'accès ne peut pas être vide',
      secretAccessKeyEmpty: 'La clé d\'accès secrète ne peut pas être vide',
      keyIdEmpty: 'keyID ne peut pas être vide',
      applicationKeyEmpty: 'applicationKey ne peut pas être vide',
      notMediaFiles: 'Remarque : Le répertoire "Albums" ne peut stocker que les répertoires d\'album, mais pas les fichiers multimédias.',
      notStoreDirectories: 'Le répertoire "Photos" ne peut pas stocker de répertoires.',
      onlyStoreImages: 'Remarque : Le répertoire "Photos" ne peut stocker que des images, des vidéos et d\'autres fichiers multimédias,mais pas des répertoires ',
      unknownError: 'La connexion à ce service a échoué. Veuillez réautoriser l\'accès de MultCloud au service.',
      renameCloudFailed: 'Impossible de renommer le cloud. Veuillez réessayer plus tard.',
      deleteCloudFailed: 'Impossible de supprimer le cloud. Veuillez réessayer plus tard.',
      invalidCloudAccount: 'Ce compte cloud n\'existe pas.',
      bindEmailFail: 'Échec de la liaison de l\'e-mail.',
      linkHasExpired: 'Le lien a expiré.',
      listItemsFailed: 'Échec de la liste des fichiers, veuillez rajouter le cloud à MultCloud.',
      deleteItemFailed: 'Impossible de supprimer l\'élément.',
      renameItemFailed: 'Impossible de renommer l\'élément.',
      createFolderFailed: 'Échec de la création du dossier.',
      moveItemFailed: 'Impossible de déplacer l\'élément.',
      shareItemFailed: 'Échec de partage de l\'élément.',
      uploadFailed: 'Données de fichier non trouvées.',
      toFolderIdBlanked: 'Le "tid" est masqué',
      downloadFileFailed: 'Échec du téléchargement du fichier, veuillez actualiser la page ou ajouter à nouveau le cloud à MultCloud.',
      addTaskFail: 'Échec de l\'ajout de la tâche.',
      taskQuotaLimit: 'Vous avez atteint le nombre maximum de 1000 tâches de transfert de cloud à cloud, veuillez supprimer certaines tâches.',
      deleteTaskFail: 'Échec de la suppression de la tâche.',
      maxRunningLimit: 'La tâche en cours d\'exécution dépasse le nombre maximum et cette tâche peut être ajoutée en attente',
      userCreateFail: 'Impossible de créer un utilisateur, veuillez réessayer plus tard.',
      userUpdateFail: 'Échec de la modification des informations de compte, veuillez actualiser la page et réessayer.',
      createSaltFail: 'Impossible de créer Salt, veuillez réessayer.',
      listFolderFailed: 'Échec de la liste du dossier, veuillez essayer de rajouter le cloud.',
      cloudCategoryInvalid: 'Le service cloud n\'est plus pris en charge.',
      executeTaskFail: 'Échec de l\'exécution de la tâche, veuillez vérifier votre connexion Web.',
      parameterInvalid: 'Les paramètres ne sont pas valides',
      saltInvalid: 'Votre session a expiré, veuillez vous reconnecter.',
      emailInvalid: 'Ce n\'est pas un email valide.',
      notAuthorized: 'Le nom d\'utilisateur ou le mot de passe n\'est pas correct.',
      cloudNameEmpty: 'Le nom ne peut pas être vide.',
      addCloudExpired: 'Échec de l\'ajout du cloud, veuillez rajouter le service cloud.',
      verifyCodeInvalid: 'Le code de vérification n\'est pas valide.',
      emailExist: 'L\'e-mail existe déjà.',
      exceedMaxLimit: 'Les demandes dépassent le nombre maximum.',
      userIdNotNull: 'L\'ID utilisateur est nul',
      notFoundTask: 'La tâche est introuvable.',
      noTaskRunning: 'Aucune tâche n\'est en cours d\'exécution',
      userNotFound: 'L\'utilisateur est introuvable.',
      loginerNotFound: 'Le loginer n\'est pas pris en charge',
      deletePermissionLimited:'Vous ne pouvez pas procéder à cette opération, car vous n\'avez pas « l\'autorisation de suppression ».',
      notHaveDeletePermission: 'Vous n\'êtes pas autorisé à supprimer le fichier/dossier.',
      uploadPermissionLimited:'Vous ne pouvez pas procéder à cette opération, car vous n\'avez pas « l\'autorisation de Upload ».',
      movePermissionLimited:'Vous ne pouvez pas procéder à cette opération car vous n\'avez pas « l\'autorisation de déplacement »',
      copyPermissionLimited:'Vous ne pouvez pas procéder à cette opération car vous n\'avez pas « l\'autorisation de copie »',
      notHavePermission: 'Vous ne pouvez pas coller ce fichier/dossier faute d\'autorisation d\'écriture.',
      mkdirPermissionLimited:'Vous ne pouvez pas procéder à cette opération, car vous n\'avez pas « l\'autorisation de création de dossier ».',
      notCreatPermission: 'Vous ne pouvez pas créer de bucket ou de dossier par manque d\'autorisations d\'écriture ou d\'espace insuffisant.',
      renamePermissionLimited:'Vous ne pouvez pas procéder à cette opération, car vous n\'avez pas « l\'autorisation de renommer ».',
      creatIDriveFolderError: 'Le nom de l\'objet contient des caractères non pris en charge.',
      creatIDriveFolderToLong: 'Le nom du dossier ne peut pas dépasser 245 caractères.',
      noUploadPermission: 'En raison du manque d\'autorisations de téléchargement ou d\'un espace de stockage cloud insuffisant, vous ne pouvez pas télécharger ce fichier.',
      bucketNameLongError: 'Les noms de buckets doivent comporter de 3 à 63 caractères, n\'utiliser que des lettres minuscules, des chiffres, des points (.) et des traits d\'union (-), commencer et se terminer par une lettre ou un chiffre et éviter les points consécutifs.',
      bucketNameIsNotIp: 'Le nom du bucket ne peut pas être une adresse IP.',
      downloadPermissionLimited:'Vous ne pouvez pas procéder à cette opération, car vous n\'avez pas « l\'autorisation de téléchargement ».',
      ipNotFound: 'L\'IP est introuvable',
      sugarSyncWarn: 'La sélection du répertoire n\'est pas prise en charge, veuillez sélectionner le répertoire "Web Archive", "Magic Briefcase", "Mobile Photos", ses sous-dossiers ou d\'autres répertoires.',
      flickWarn: 'Le répertoire que vous sélectionnez n\'est pas pris en charge, sélectionnez le répertoire "/Albums", ses sous-dossiers ou d\'autre répertoire.',
      baiDuWarn: 'Le répertoire que vous sélectionnez n\'est pas pris en charge, sélectionnez le répertoire "全部文件/我的应用数据/MultCloud", ses sous-dossiers ou d\'autre répertoire.',
      dropBoxbusinessWarn: 'Le répertoire racine que vous sélectionnez n\'est pas pris en charge, sélectionnez un autre répertoire.',
      onlyAlbum: 'Seuls les répertoires d\'albums créés ou partagés par MultCloud peuvent être sélectionnés pour stocker des images, des vidéos et d\'autres fichiers multimédia.',
      createFolderFail: 'Échec de la création du dossier',
      parametersNotEmpty: 'Les paramètres ne peuvent pas être vides',
      //mega报错
      addMegaFailed: 'Certains paramètres ne sont pas saisis correctement ou vous avez activé F2A.',
      //mySql报错
      mySqlWarn:'Ce cloud ne peut pas être sélectionné comme cible du transfert cloud-à-cloud.',
       //2020-10-29ljm新增
      maxTaskRemind:'Vous avez atteint le nombre maximum de 5 000 tâches de transfert/synchronisation cloud. Veuillez supprimer certaines tâches inutiles et réessayer. P.S. S\'il y a 3 sources dans une tâche de transfert, la tâche de transfert comptera comme 3 tâches.',
      // 2020-11-25 yjs
      torrentTort:'Ce contenu est des copies non autorisées ou contrefaites',
      //2020-12-4 xth
      shareNotUpload:'Le propriétaire a annulé l\'autorisation \"autoriser le téléchargement\", veuillez actualiser la page.',
      //2020-12-9 xth
      shareItemUpdate:'Le propriétaire a modifié l\'autorisation du lien de partage, veuillez actualiser la page.',
      nameLong:'Le nom d\'utilisateur est trop long (au plus 20 caractères).',
      notPermission:'C\'est un fichier d\'équipe et vous n\'avez pas la permission d\'effectuer cette opération.',
      notOpened:'Ce Cloud ne supporte pas la synchronisation en temps réel.',
      taskNotFound:'La tâche n\'existe pas.',
      subscribeFail:'Échec de la création d\'une tâche.',
      driveAccountIdInvalid:'Impossible de créer une tâche de synchronisation en temps réel. Veuillez supprimer et rajouter les services cloud sélectionnés et réessayer.',
      unknownState:'Impossible d\'exécuter cette opération, veuillez réessayer plus tard.',
      InvalidParameter:'Paramètre invalide.',
      InvalidDirectory:'Le répertoire racine de box ne supporte pas cette fonctionnalité.',
      HasExist:'La tâche de synchronisation instantanée pour ce dossier existe déjà, veuillez annuler la tâche de synchronisation instantanée pour ce dossier et la recréer dans le dossier',
    //   taskRunningNumberLimited:'Vous pouvez exécuter 5 tâches cloud-à-cloud en parallèle, veuillez annuler une tâche en cours et réessayer.',
      taskRunningNumberLimited:'Il y a déjà 2 tâches de synchronisation en temps réel en cours d\'exécution et veuillez d\'abord suspendre une tâche de synchronisation en temps réel.',
      reachedLimit:'Vous avez atteint la limite de débit de ce cloud, veuillez réessayer plus tard.',
      notSupported:'La synchronisation en temps réel n\'est actuellement pas prise en charge pour les tâches multi-cibles.',
      incorrectFormat:'Désolé, le format de votre numéro de téléphone est incorrect',
      taskMaximumNumberLimited:'Vous avez atteint le nombre maximum de 200 tâches de synchronisation en temps réel. Veuillez supprimer certaines tâches de synchronisation en temps réel inutiles et réessayer.',
      autoLoginFail: 'Vous avez activé la vérification en deux étapes, veuillez vous reconnecter.',
      unsubscribeFail:'échec de la désinscription',
      //云盘操作报错
      alreadyAdd:'Vous avez déjà ajouté le cloud',
      toggleWhileEditing:'Le compte que vous avez ajouté ne correspond pas au compte actuel.',
      unsubscribeFail:'échec de la désinscription',
      //2022-4-25 wt
      emptyBucket:'Vous ne pouvez pas supprimer des compartiments qui ne sont pas vides. PS : Veuillez vous assurer qu\'il n\'y a pas non plus d\'objets dans la version de compartiment de Wasabi.',
      cannotCopyFolder:'Vous ne pouvez pas copier un dossier au même compartiment.',
      cannotCopyIdrivee2Folder: 'Les dossiers du même compte Idrive e2 ne peuvent pas être copiés l\'un sur l\'autre.',
      cannotCutFolder:'Les dossiers du même bucket ne peuvent pas être coupés et collés les uns aux autres.',
      bucketAlreadyExists:'Le nom de compartiment demandé n\'est pas disponible. L\'espace de noms de compartiment est partagé par tous les utilisateurs du système. Veuillez sélectionner un autre nom et réessayer.',
      accessPermissionLimited:'Vous n\'êtes pas autorisé à accéder à ce dossier.',
      accessDenied:'Accès refusé, vous n\'êtes pas autorisé à effectuer cette opération.',
      shareTransferCanotCopy: 'La copie du dossier racine d\'un partage multi-éléments n\'est pas prise en charge pour le moment.',
      // 2022-6-8 wt
      sharePointOnlineNotTrans: 'Le répertoire racine de SharePoint ne peut pas être sélectionné pour le transfert de fichiers, veuillez sélectionner un sous-répertoire d\'un site.',
      sharePointListFailed: 'Erreur 500: InternalServerError. Conseils : Veuillez vérifier si ce compte a accès au service SharePoint.',
      sameDirError: 'Le compte source et le compte cible ne peuvent pas être les mêmes.',

      accessDenied:'Accès refusé',
      //iCloudPhotos报错
    onlySaveAlbums: 'Note : Le répertoire cible sélectionné ne peut enregistrer que des albums (dossiers).',
    notSelectICloudPhotosRoot: 'Note : Le répertoire racine de Photos iCloud ne peut enregistrer que des albums (dossiers).',
    notSelectICloudPhotosForder: 'Note : Le répertoire cible sélectionné ne peut enregistrer que des albums (dossiers).',
    notSelectICloudPhotosAlbum: 'Note : Le répertoire cible sélectionné ne peut enregistrer que des images (dossiers non disponibles).',
    notSelectICloudPhotosOther: 'Note : Le répertoire cible sélectionné ne peut pas enregistrer directement les images, toutes les images transférées seront enregistrées dans le dossier « Récents ».',
    notSelectICloudPhotosBackup: 'Photos iCloud ne peut pas être sélectionné comme cible pour « Sauvegarde de Cloud ». Pour sauvegarder des images dans Photos iCloud, veuillez sélectionner « Transfert de Cloud » ou « Synchronisation de Cloud ».',
    notSelectICloudPhotosSyncRoot: 'Note : Il est impossible de synchroniser des images dans le répertoire racine de Photos iCloud.',
    notSelectICloudPhotosSync: 'C\'est un dossier dans Photos iCloud, vous pouvez uniquement synchroniser des images vers des albums dans Photos iCloud.',
    sendTooMany: 'Trop de codes de vérification ont été envoyés. Saisissez le dernier code que vous avez reçu, utilisez l\'un de vos appareils ou réessayez plus tard.',
    verifySecurityCodeFailed: 'La vérification a échoué, veuillez vérifier et saisir à nouveau le code de vérification.',
    appleNotEnablePhotos: 'Photos iCloud n\'est pas disponible pour votre identifiant Apple. Pour utiliser Photos iCloud, connectez-vous avec un identifiant Apple que vous utilisez sur un appareil Apple.',
    tooManyRequests429: 'Limite de taux d\'utilisation dépassée. Réessayez après {date}.',
    tooManyRequests403: 'Trop de demandes en même temps, veuillez réessayer plus tard.',
    // iCloudDrive报错
    folderNameIsTooLong: 'Le nom du dossier ne peut pas dépasser 255 caractères.',
    fileNameIsTooLong: 'Le nom du fichier ne doit pas dépasser 250 caractères.',
    iCloudDriveNotEnoughSpace: 'Il n\'y a pas assez d\'espace pour charger le fichier.',
    uploadFileIsTooBig: 'Le fichier est trop volumineux pour être téléchargé. MultCloud limite actuellement les chargements à 100 Mo maximum.',
    uploudFileSizeIsZero: 'Il n\'est pas possible de transférer dans iCloud Drive des fichiers dont la taille est de zéro octet.',
    notUploudSpecialFile: 'Impossible de charger ce type de fichier dans la bibliothèque de cette app.',
    notRenameApp: 'Apple ne permet pas de renommer les dossiers App, tels que Pages, Numbers et Keynote.',
    ErrorDeleteDistinguishedFolder: 'Les dossiers distincts ne peuvent pas être supprimés.',
    moreThan256Characters: 'Le nom du dossier ne peut pas dépasser 256 caractères.',
    cloudNotFound: 'Le Cloud a été supprimé.',
    fourSharedUnauthorized:'Votre autorisation 4shared a expiré. Veuillez ré-autoriser votre compte en cliquant sur "Rajouter".',
    fileFolderNameLengthExceed:"Le nom de fichier/dossier ne peut pas dépasser 255 caractères.",
    invalidLink: 'Lien invalide.',
    requestFailed: '',
    exceeds2GB: 'La taille du fichier dépasse 2 Go et ne peut pas être téléchargée.',
    licenseUpgradError: 'La licence n\'est pas disponible car vous êtes abonné à {scheme}',
    noLicenseCode: 'Veuillez saisir un code de licence',
    licenseCodeError: 'Le code de licence que vous avez saisi est incorrect',
  },
  preview: {
      fileNotReview: 'les fichiers ne peuvent pas être examinés',
      goOringinalSite: 'Aller au site Original'
  },
  remoteTask: {
      remoteTask: 'Tache à distance',
      createTask: 'Créer une tache',
      successsExceed: 'Lien copié !',
      operateSuccess: 'Opérer avec succès',
      noRemote: 'Aucune tâche distante n\'a été créée',
      unKnownError: 'Une erreur inconnue',
      undefinedDisk:"Impossible de trouver le répertoire cible, veuillez copier le lien de téléchargement et créer une nouvelle tâche de téléchargement à distance.",
      taskExpired:'La tâche a expiré. Veuillez réessayer.',
      createDescribe:'Transférer des fichiers depuis des liens, des torrents, des aimants directement vers vos clouds',
      saveURLDescribe:'Enregistrer des fichiers de liens URL dans vos clouds',
      excuteNow:'Exécuter maintenant',
      noSeeds:'Faible Ressource',
      failedToParse:"Échec de l'analyse.",
      parseMagnetRunning:'Analyser les graines, veuillez patienter...',
      selectedFileLimit:'Le nombre total de fichiers sélectionnés ne peut pas dépasser 500 ou la taille dépasse 50G.',
      addLink: 'Ajouter un lien',
    startEmailSend: 'Envoyer une notification par e-mail à la fin de cette tâche',
    nowUpload: 'Téléverser maintenant',
  },
  shares: {
      myShares: 'Mes partages',
      savedShares: 'Partages enregistrés',
      sharedOn: 'Partagé sur',
      allowedTo: 'Autoriser à uploader',
      location: 'Emplacement',
      shareNull: 'Vous n\'avez encore partagé aucun fichier.',
      shareNullTips: 'Conseils: Pour partager un fichier, vous pouvez faire un clic droit sur le fichier et sélectionner l\'option « Partager ».',
      savedShareNull: 'Vous n\'avez encore enregistré aucun fichier partagé.',
      savedShareNullTips: 'Conseils: si quelqu\'un partage un lien de partage avec vous, vous pouvez l\'enregistrer ici pour un accès rapide.',
  },
  login: {
      experienceSigning: 'Accès sans inscription',
      forgotPassword: 'Mot de passe oublié ?',
      signIn: 'S\'identifier ',
      rememberMe: 'Souviens-toi de moi',
      keepLogin: 'Rester connecté',
      loginWith: 'Connectez-vous avec',
      email: 'E-mail',
      password: 'Mot de passe',
      verificationCode: 'Verification Code',
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      confirmPassword: 'Confirmer le mot de passe',
      createAccount: 'Créer un compte',
      continueWith: ' ou continuer avec',
      resetMessage: 'Envoyer un message de réinitialisation',
      enterEmail: 'Entrer l\'adresse e - mail avec laquelle vous vous êtes inscrit ci - dessous.Un e - mail vous sera envoyé contenant un lien pour réinitialiser votre mot de passe.',
      enterCorrectEmai: 'Veuillez saisir le format correct de l\'adresse e - mail.',
      passwordCharacters: 'Le mot de passe doit être composé de 8 à 16 caractères',
      passwordDiff: 'Les deux mots de passe entrés sont incohérents',
      enterCode: 'Veuillez saisir le code de vérification.',
      sentSuccess: 'L\'e - mail a été envoyé avec succès.',
      successfully: 'S\'inscrire avec succès ',
      pleaseEmail: 'Veuillez saisir votre email',
      pleasePassword: 'Veuillez saisir votre mot de passe',
      accountActivated: 'Votre compte n\'a pas été activé.',
      enterCorrectPass: 'Veuillez saisir la bonne adresse e-mail ou le nom et le mot de passe du compte temporaire.',
      resetPasseord: 'Pour protéger votre compte, veuillez cliquer sur "Mot de passe oublié" pour réinitialiser votre mot de passe.',
      validEmail: 'Veuillez saisir un e-mail valide',
      enterFirstName: 'Veuillez saisir votre prénom.',
      enterLastName: 'Veuillez entrer votre nom de famille.',
      reEnterPass: 'Veuillez ressaisir votre mot de passe.',
      creatingAccount: 'En créant un compte, vous acceptez les',
      termsUse: 'Conditions d\'utilisation ',
      privacyPolicy: 'Politique de confidentialité',
      thankYou: 'Merci !',
      checkEmail: 'Veuillez vérifier votre e-mail',
      confirmRegistration: 'pour confirmer votre inscription. Vous pouvez ignorer le processus d\'activation et utiliser notre produit normalement,mais si vous oubliez votre mot de passe,nous ne pouvons pas vous aider à le récupérer.',
      noteReceiveEmail: 'Vous n\'avez pas reçu d\'e-mail ?',
      receiveConfirmationEmail: 'Si vous n\'avez pas reçu d\'e-mail de confirmation, veuillez nous envoyer un e-mail à',
      buttonResend: 'ou cliquez sur le bouton pour renvoyer.',
      forgetEmail: 'Vous avez oublié votre adresse e-mail ?',
      sendEmailSupport: 'Envoyer un e-mail au support',
      trackDown: 'et nous le retrouverons.',
      passwordnotMatch: "Le mot de passe que vous avez entré ne correspond pas",
      enterVaildPassWord: 'Veuillez saisir un mot de passe valide',
      usernameNotContain: 'Le nom d\'utilisateur ne peut pas contenir de caractères spéciaux.',
      updatedSuccessfully: "Vos données ont été mises à jour avec succès",
      thankBindEmail: 'Merci pour l\'adresse e-mail de liaison, veuillez vérifier l\'e-mail d\'activation à temps',
      failExceedOperation: 'Impossible de dépasser cette opération',
      enterNewPassword: 'Veuillez saisir le nouveau mot de passe',
      confirmationPassword: 'Veuillez saisir le mot de passe de confirmation',
      userNameNot: 'le nom d\'utilisateur ne peut pas être vide',
      //login popup用
      signUp: 'S\'inscrire',
      logInButton: 'S\'identifier',
      logInWith: 'Connectez-vous avec',
      logToMultCloud: 'Connectez-vous à MultCloud',
      logEmailInput: 'E-mail/Nom du compte temporaire',
      verificationIncorrect: 'La vérification entrée est incorrecte.',
      signUpTitle: 'Inscrivez-vous et obtenez un trafic de données de 5 Go gratuit chaque mois',
      title: "Transférez-le vers vos services cloud avec MultCloud.",
      tips: "Vous avez déjà un compte ?",
      tips2: "Vous n'avez pas de compte ?",
      btnTxt: "Connexion...",
      facebook: "Facebook",
      google: "Google",

      exception: {
          strEmpty: "Veuillez remplir ce champ.",
          nameToLong: "Votre nom d'utilisateur doit comporter entre 1 et 20 caractères.",
          emailError: "Veuillez saisir une adresse e-mail valide.",
          pwdError: "Veuillez saisir un mot de passe de 8 à 16 caractères.",
          rePsdEmpty: "Veuillez re-taper votre mot de passe.",
          rePwdError: "Le mot de passe ne correspond pas.",
          codeEmpty: "Veuillez saisir le code de vérification.",
          codeError: "Le code de vérification doit comporter 4 caractères.",
          verifyCodeInvalid: "Le code de vérification est incorrect.",
          emailExist: "L'adresse e-mail a déjà été enregistrée.",
          emailPsdError: "L'e-mail/nom du compte temporaire ou mot de passe est incorrect.",
      }
  },
  home: {
      driveNameNotContain: 'Le nom du disque ne peut pas contenir de caractères spéciaux `/ \ | : * ? " < >  &`.',
      cloudDiskName: 'Le nom du disque cloud ne peut pas dépasser 200 caractères.'
  },
  sharesPage: {
      linkFailure: 'Désolé, ce fichier partagé a été annulé.',
      linkMasking: 'Désolé, ce fichier partagé a été bloqué.',
      saveCloud: 'Enregistrer vers cloud',
      directDownload: 'Télécharger',
      saveLink: 'Enregistrer le lien',
      cancelShare:'Annuler Partage',
      uploadFile: 'Téléverser un fichier',
      newFolder: 'Nouveau dossier',
      saveLinkSuccessBefore: 'Vous avez enregistré le lien avec succès.',
      saveLinkSuccessAfter: ' Affichier les liens enregistrés',
      saveLinkFail: 'Échec de l\'enregistrement du lien',
      downloadingFolder: 'Le téléchargement du dossier n\'est pas pris en charge.',
      downloadingMore: 'Vous ne pouvez télécharger qu\'un seul fichier à la fois.',
      downloadingNone: 'Veuillez sélectionner un fichier.',
      sharecanceledSuccess: 'Partage annulé.',
      sharecanceledFailed: 'Échec de l\'annulation du partage.',
      newFolderInRoot: 'Veuillez entrer des sous-répertoires pour créer un nouveau dossier.',
      uploadFileInRoot: 'Veuillez entrer des sous-répertoires pour téléverser un fichier.',
      selectFileTransfer: 'Veuillez sélectionner un fichier à transférer.',
      createTransferFailed: 'Impossible de créer la tâche de transfert',
      createTransferSuccessBefore: 'Vous avez créé avec succès une tâche de transfert.',
      createTransferSuccessAfter: '  Affichier la tâche.',
      addCloudService: 'Ajouter un service cloud',
      mustAddClouds: 'Vous devez ajouter un lecteur cloud valide',
      selectSaveCloudTitle: 'Veuillez sélectionner',
      moreClouds:'Plus de clouds',
      saveLinkExists: 'Le lien existe déjà.',
      errorShare404: 'Fichier source n\'est pas trouvé.',
      passWordError: 'Mot de passe incorrect !',
      passWordNone: 'Le mot de passe ne doit pas être vide.',
      passWordInputTitle: 'Fichier de partage privé MultCloud',
      passWordInputMsg: 'Veuillez saisir le mot de passe.',
      passWordInputButton: 'OK',
      loginErrorMax: 'Vous n\'avez pas mis à jour votre mot de passe depuis longtemps, veuillez mettre à jour votre mot de passe.',
      uploadFolder: 'Actuellement, vous ne pouvez télécharger que des fichiers.',
      pleaseSignIn: 'Veuillez vous connecter à MultCloud.',
  },
  share:{
      noManageMyShare: "Vous pouvez gérer tous vos fichiers partagés ici.",
      noManageSavedShare: "Vous pouvez gérer tous les partages enregistrés ici.",
      unknownError: "Le fichier de partage est perdu, il peut être déplacé ou supprimé.",
      privateShareText: "(Veuillez me contacter pour obtenir le mot de passe)",
  },
  inviteFriends:{
      titleBefor: 'Invitez autant d\'amis que possible et obtenez ',
      titleAfter: ' de données pour chaque ami invité ! Pas de limite de quota !',
      shareEmailTitle: 'Partager l\'invitation : ',
      shareLinkTitle: 'Partager le lien d\'invitation : ',
      emailSend: 'Envoyer',
      emailTip: 'Ajoutez une adresse e-mail ici',
      wonMonthFlows: 'Trafic supplémentaire à vie que vous avez gagné ce mois-ci : ',
      wonMonthTitle: 'Obtenu une chance de gagner un trafic de données ILLIMITÉ À VIE !',
      lastWinner: 'Dernier gagnant ',
      winnerInvites: 'Avec {num} invités',
      winnerTip: 'Gagné ILLIMITÉ À VIE ',
      statusTitle: 'Votre état de partage',
      successInvites: 'Invitations réussies ce mois-ci : ',
      chanceWin: 'Chance de gagner : ',
      tipsTitle: 'Termes',
      tipsOne: "Seuls les utilisateurs invités avec un e-mail vérifiée comptent comme une invitation réussie.",
      tipsTwo: 'Aucune limite de quota pour le trafic que vous gagnez en invitant des personnes.',
      tipsThird: 'Si vous êtes déjà abonné à un trafic illimité, vous ne pouvez pas gagner 2 Go à partir d\'une invitation réussie, mais vos chances de gagner le service illimité à vie seront doublées.',
      shareText: 'MultCloud - Transférer et gérer vos multiples fichiers cloud avec une seule application. Rejoignez MultCloud aujourd\'hui et bénéficiez de 2 Go de trafic cloud à cloud ! ',
  },
  paySystem:{
      billed:'Le trafic supplémentaire est 0,099 $/GB',
      subCould:'Les abonnés peuvent acheter 50 Go/5,9 € et 100 Go/9,9 € pour un trafic de données supplémentaire si le trafic de données ne suffit pas',
      limitedMonth:'150 Go/mois',
      limitedTrafficMonth:'150 Go Trafic/mois',
      unlimitedTraffic:'Trafic illimité à vie!',
      foraYear:'Trafic illimité pendant un an',
      noNeedPurchase:'Pas besoin d\'acheter du trafic supplémentaire',
      yearlyPayment:'Paiement annuel (7,5€/mois)',
      validityData:'Votre trafic acheté est valable à vie',
      additionalPackage:'Forfait trafic supplémentaire',
      subscriptmc:'Votre abonnement à MultCloud',
      upgradeMore:'Mise à niveau vers MultCloud Premium pour plus de trafic de transfert et des avantages supplémentaires',
      recommended:'Recommandé',
      toUnlimited:'Acheter la Version Illimitée',
      otherPlan:'Autres plans',
      moreTraffic:'Acheter plus de trafic',
      monthlySubscriber:`Vous êtes un abonné mensuel et vous avez un trafic de 150 Go pour transférer ou synchroniser des données <br> entre les clouds chaque mois.`,
      moreDetails:`<a class='add-cloud-link sysLink'>Plus de détails sur les privilèges</a>`,
      dataTraffic:'Le trafic de données utilisé du mois en cours',
      cloudTraffic:'Trafic cloud vers cloud',
      buyNow:'Acheter maintenant',
      specialOffer:'Offre spéciale',
      lifetimeFree:'Gratuit à vie',
      unsubscribe:'Se désabonner',
      includes:'Comprend',
      reSubscription:'Réactiver l\'abonnement',
      monthTraffic:'Trafic illimité pendant un mois',
      threeMonth:'30 Go/mois',
      monthlyPayment:'Paiement mensuel',
      monthlyUnlimited:'Mensuel illimité',
      gb:'Go',
      YearlyUnlimited:'Annuel illimité',
      YearlyPaymentNine:'Paiement annuel (9,9€/mois)',
      Onetime:'Paiement unique',
      twoMonthree:'200 Go/mois x3',
      QuarterlyPayment:'Paiement trimestriel (8,3€/mois)',
      fourMOne:'400 Go/mois x12',
      quarterlySubscriber:`Vous êtes un abonné trimestriel et vous disposez d'un trafic de données de 200 Go pour transférer ou synchroniser des données <br>  entre le stockage cloud`,
      yearlySubscriber:`Vous êtes un abonné annuel et vous disposez d'un trafic de données de 400 Go pour transférer ou synchroniser des données <br> entre le stockage cloud`,
      expireIn:'Expire dans',
      billYearly:'Facturé annuellement',
      billMonthly:'Facturé mensuellement',
      billQuarterly:'Facturé trimestriellement',
      twoMonTrafficthree:'200 Go Trafic/mois x3',
      fourMTrafficOne:'400 Go Trafic/mois x12',
      deleteSubAccount:'Vous devez vous désinscrire pour supprimer votre compte, êtes-vous sûr de le faire?',
      payFirst:'Vous devez',
      paybindEmail:`<a class='add-cloud-link sysLink'>vous connecter à votre adresse e-mail et le vérifier </a>`,
      payEnd:'pour vous abonner, car nous devons assurer que vous pouvez recevoir avec succès l\'e-mail important concernant votre abonnement.',
      yearlyPaymentTxt:'Paiement annuel',
      quarterlyPaymentTxt:'Paiement trimestriel',
      //2021-5-20新加
      //1
      upUnlimited:'Mises à niveau annuelles illimitées',
      //2
      payDiff:'Ne payez que la différence de prix!',
      //3
      yearlyUnlimit:'MultCloud (<b>illimité par an</b>)',
      //4
      providesUnlimited:'Le plan illimité annuel fournit un trafic de données illimité pour transférer ou synchroniser des données entre les services de stockage cloud pendant 12 mois.',
      //5
      subProduct:'C\'est un produit d\'abonnement avec des frais de',
      perYear:'par an.',
      cancelSubscription:'Vous pouvez annuler votre abonnement à tout moment.',
      //6
      defaultPayment:'Le mode de paiement par défaut est',
      //7
      anotherPayment:'Si vous souhaitez utiliser un autre mode de paiement, veuillez',
      clickHere:' cliquer ici',
      //8
      tryAgain:'Le paiement ne peut pas être effectué pour le moment. Veuillez vérifier votre mode de paiement et réessayer.',
      //9
      contactPayment:'Vous avez un problème avec le paiement? N\'hésitez pas à contacter <a href="mailto:support@multcloud.com">support@multcloud.com</a>',
      //10
      Notice:'Attention',
      beforeBind:'Veuillez lier votre e-mail avant de mettre à niveau votre abonnement.',
      processorder:'Commande en traitement',
      eachGbMoney:'0,12€/',
      eachGbMoneyT:'0,10€/',
      payCouponQuartly:'Paiement trimestriel(6.63€/mois)',
      payCouponlimitedYearly:'Paiement annuel(5.83€/mois)',
      payCouponunlimitedYearly:'Paiement annuel(7.50€/mois)',
      payCouponunlimitedYearlyLow:'Paiement annuel(6.67€/mois)',
      tips:'Conseils : Si vous avez des questions, n\'hésitez pas à contacter <a href="mailto:support@multcloud.com">support@multcloud.com</a>.',
      monthly:'Mensile 150GB',
      //新版付费页面
      payTitle: 'Choisissez le MultCloud qui vous convient !',
      limitedData: 'Données limitées',
      unlimitedData: 'Données illimitées',
      monthly: 'Mensuellement',
      annually: 'Annuellement',
      save58: 'Économisez jusqu\'à 58 %',
      payTip: 'Contactez notre Équipe de Vente',
      limitTips: 'Le trafic de données inutilisé seront accumulé',
      unlimitTips: 'Plus de souci de limite de données',
      tips2: 'Si vous rencontrez des problèmes lors de l\'achat en ligne, n\'hésitez pas à nous contacter: <a href="mailto:support@multcloud.com">support@multcloud.com</a>',
    vipUpgradeTips: 'Voici l’offre pour les utilisateurs du plan {type}.',
    tabPayScheme: {
          perMonth: 'Paiement mensuel',
          perYear: 'Paiement annuel',
          perNextYear: 'pour la première année (renouveler à {price})',
          refundDays: 'Jours de Remboursement Garanti',
          advanced: 'Fonctions avancées',
          payPremium: 'Passez à n\'importe quel plan premium et profitez de toutes les fonctionnalités avancées ci-dessous',
          payUnlimited: 'Passez à n\'importe quel plan ILLIMITÉ et profitez de toutes les fonctionnalités avancées ci-dessous',
          freeTip1: 'Plus de trafic de données cloud à cloud',
          freeTip2: 'Trafic de données cloud à cloud ILLIMITÉ',
          freeTip3: 'Transfert/synchronisation/sauvegarde planifiés',
          freeTip4: 'Sync Double',
          freeTip5: '10 Fils de Transfert',
          freeTip6: '8 Modes de Sync',
          freeTip7: 'Filtre de Fichiers',
          freeTip8: 'Serveur de Transfert VIP',
          freeTip9: 'Service de Client VIP',
          freeTip10: '5 tâches cloud-à-cloud en parallèle',
          freeTip11: 'Conversions d\'e-mails illimitées',
          freeTipTitle1: 'Les abonnés peuvent avoir 2 tâches de synchronisation en temps réel et 2 tâches de synchronisation normales (4 au total).',
          freeTipTitle2: 'Il y a 10 fils de transfert pour les abonnés tandis que 2 fils de transfert pour les utilisateurs gratuits.',
          freeTipTitle3: 'Synchronisation bidirectionnelle et 7 options personnalisées en synchronisation unidirectionnelle, synchronisation miroir prise en charge.',
          freeTipTitle4: 'Configurer un filtre pour transférer ou synchroniser des fichiers avec un nom de fichier défini par l\'utilisateur ou certaines extensions automatiquement.',
          freeTipTitle5: 'Les abonnés peuvent exécuter 5 tâches cloud-à-cloud en parallèle alors que les utilisateurs gratuits peuvent exécuter 1 tâche à la fois.',
          freeTipTitle6: 'Les abonnés peuvent convertir un nombre illimité d\'e-mails en PDF, tandis que les utilisateurs gratuits sont limités à convertir 50 e-mails par mois.',
      },
      nowPayScheme: {
        clearInsCountText: 'Mais le quota de téléchargement inutilisé pour les profils Instagram sera réinitialisé.',
        manageYourPlan: 'Gérer votre abonnement',
        price: 'Prix',
        paymentMethon: 'Méthode de paiement',
        autoRenewal: 'Renouvellement automatique',
          priceVat: 'Comprend {currency}{vatPrice} de TVA ({percent}% sur {currency}{netPrice}).',
          defaultPayment: '{method}, xxxxxxxxxxxx{num}.',
          paypalPayment: 'Le mode de paiement par défaut est PayPal.',
          changePayment: 'Changer la méthode de paiement',
          activated: 'Prochaine date de facturation {time}',
          deactivated: 'Prochaine date de facturation {time}',
          appleTip: 'Vos {name} actuels ont été achetés dans l\'Apple Store.',
        appleTipId: 'ID de transaction Apple : {id}.',
        googleTip: 'Votre abonnement actuel de {name} a été acheté dans Google Play.',
        googleTipId: 'ID de commande Google Play : {id}.',
        appNextTimeTip: 'Le renouvellement automatique est activé. La prochaine date de facturation sera le {time}.',
        appNoSubscribe: 'Le renouvellement automatique est désactivé.',
      },
      // 免费用户弹窗
    freePlanPopup: {
        title_traffic: 'Oups ! Trafic cloud-à-cloud insuffisant',
        title_ins: 'Vous avez atteint la limite de téléchargements',
        title_pdf: 'Vous avez atteint la limite de conversion d\'email en PDF',
        title_modes: 'Ce mode est réservé aux Premium',
        title_remote: 'Vous avez atteint la limite de téléversement à distance',
        title_subtasks: 'Vous avez atteint la limite pour le transfert d’équipe',
        title_scheduled: 'La fonction de planification est réservée aux forfaits premium',
        title_speed: 'Vitesse de transfert quintuple réservée aux premium',
        title_sync: 'Vous avez atteint la limite pour la synchronisation normale',
        title_real: 'Vous avez atteint la limite pour la synchronisation en temps réel',
        title_filter: 'Le filtre de fichiers est exclusif aux plans Premium',
        desc: 'Mettez à niveau pour débloquer TOUTES les fonctionnalités avancées',
        itemTitle_th: 'Caractéristiques et avantages',
        itemTitle_traffic: 'Trafic cloud-à-cloud',
        itemTitle_ins: 'Profils Ins à télécharger',
        itemTitle_pdf: 'Convertir E-mail en PDF',
        itemTitle_modes: 'Sync Modes',
        itemTitle_remote: 'Tâches de téléchargement à distance en parallèle',
        itemTitle_subtasks: 'Migrer les sous-comptes entre les équipes',
        itemTitle_scheduled: 'Transfert/Synchronisation/Sauvegarde programmés',
        itemTitle_speed: 'Vitesse de transfert',
        itemTitle_sync: 'Tâches de Sync normales en parallèle',
        itemTitle_real: 'Tâches de Sync en temps réel en parallèle',
        itemTitle_filter: 'Filtre de fichiers',
        itemTitle_tran: 'Serveur de transfert VIP',
        itemTitle_customer: 'Assistance clientèle VIP',
        itemTitle_watermark: 'Supprimer le filigrane d\'un e-mail PDF',
        itemValue_cur: 'Votre actuel',
        itemValue_free: 'Gratuit',
        itemValue_upgrade: 'Mettre à jour vers',
        itemvalue_premium: 'Prime',
        itemvalue_5gb: '5 GB / Mois',
        itemvalue_1profile: '1 Profil / Mois',
        itemvalue_50emails: '50 E-mails / Mois',
        itemvalue_maxUnlimited: 'Maximum Illimité',
        itemvalue_unlimited: 'Illimité',
        button: 'Mise à niveau à partir de 9,99 €',
    },
      // 套餐的支持项
    supportItem: {
        yourCurPlan: 'Votre plan actuel',
        // 第1组
        gb5: '5 Go de trafic de données gratuit par mois',
        gb100: '100 Go de trafic de données par mois',
        gb200: '200 Go de trafic de données par mois',
        gb1200: '1 200 Go de trafic de données par an',
        gb2400: '2 400 Go de trafic de données par an',
        gbUnlimitedYear: 'Trafic de données illimité par an',
        gbUnlimitedLifetime: 'Trafic de données illimité à vie',
        gbPackage50: '',
        gbPackage100: '',
        gbGiveAway500: '',
        gbGiveAway200: '',
        ins1: '1 profil Ins à télécharger par mois',
        ins10: '10 profils Ins à télécharger par mois',
        ins20: '20 profils Ins à télécharger par mois',
        ins120: '120 profils Ins à télécharger par an',
        ins240: '240 profils Ins à télécharger par an',
        insPackage50: '',
        insPackage100: '',
        insGiveAway500: '',
        insGiveAway200: '',
        pdf50: 'Convertir 50 e-mails par mois',
        pdfUnlimited: 'Conversions d\'e-mails illimitées',
        threads2: '2 threads pour le transfert de données',
        threads10: '10 threads pour le transfert de données',
        scheduled: 'Transfert/synchronisation/sauvegarde planifié',
        // 第2组
        acrossClouds: 'Transfert/synchronisation/sauvegarde entre les Cloud',
        offline: 'Transfert/synchronisation/sauvegarde hors ligne',
        subAccounts3: 'Migrer 3 sous-comptes au sein d\'un équipe',
        subAccounts1000: 'Migrer 1000 sous-comptes au sein d\'un équipe',
        highSpeed: 'Transfert de données à haut débit',
        // 第3组
        syncMode4: '4 modes de synchronisation',
        syncMode10: '10 modes de synchronisation unidirectionnelle/bidirectionnelle',
        realSync: 'Synchronisation en temps réel',
        passwordProtected: 'Partage protégé par mot de passe',
        subAccounts: 'Collaboration des sous-comptes',
        // 第4组
        cloud30: 'Plus de 30  services de stockage Cloud leaders',
        unlimitedCloud: 'Ajouter des comptes Cloud illimités',
        singleLog: 'Identifiant unique à tous les Cloud',
        support365: 'Assistance prioritaire 24/7/365',
        // 其他
        unlimitedDataTraffic: 'Trafic de données cloud-à-cloud illimité',
        unlimitedInsProfile: 'Téléchargements illimités de profils Ins',
        unlimitedAllFeatures: 'Toutes les fonctionnalités Premium',
        // VIP弹窗标题
        vipPopupTitleTraffic: 'Vous avez consommé tout le trafic de données',
        vipPopupDescTraffic: 'Mettre à niveau pour déverrouiller le trafic de données illimité',
        vipPopupTitleIns: 'Vous avez consommé tous les téléchargements de profils Instagram',
        vipPopupDescIns: 'Mettre à niveau pour débloquer des téléchargements illimités de profils Ins',
    },
      //套餐arguments参数翻译
      arguments: {
          //参数名
          title: {
              monthly100GB: '100 Go / Mois',
              monthly200GB: '200 Go / Mois',
              monthlyUnlimit: 'Données illimitées / Mois',
              yearly1200GB: '1 200 Go / An',
              yearly2400GB: '2 400 Go / An',
              yearlyUnlimit: 'Annuel illimité',
              lifetimeUnlimit: 'Données illimitées à vie',
              package50GB: '50 Go',
              package100GB: '100 Go',
            giveAway500GB: '500 Go / An',
            giveAway200GB: '200 Go / An',
          },
          tips: {
              monthly100GB: 'Par exemple : Vous n\'avez consommé que 50 Go sur 100 Go le premier mois, vous aurez 50 Go de trafic de données supplémentaires le mois suivant.',
              monthly200GB: 'Par exemple : Vous n\'avez consommé que 150 Go sur 200 Go le premier mois, vous aurez 50 Go de trafic de données supplémentaires le mois suivant.',
              monthlyUnlimit: '',
              yearly1200GB: 'Par exemple : Vous n\'avez consommé que 1 000 Go sur 1 200 Go la première année, vous aurez 200 Go de trafic de données supplémentaires l\'année suivante.',
              yearly2400GB: 'Par exemple : Vous n\'avez consommé que 2 000 Go sur 2 400 Go la première année, vous aurez 400 Go de trafic de données supplémentaires l\'année suivante.',
              yearlyUnlimit: '',
              lifetimeUnlimit: '',
              package50GB: 'Par exemple : Vous n\'avez consommé que 20 Go sur 50 Go ce mois-ci, les 30 Go inutilisés resteront encore le mois prochain',
              package100GB: 'Par exemple : Vous n\'avez consommé que 20 Go sur 100 Go ce mois-ci, les 80 Go inutilisés resteront encore le mois prochain',
          }
      },
  },
  //双重验证功能
  twoStepverification:{
      bind:'Lier l\'e-mail d\'abord',
      addVerify:'Vous devez ajouter un moyen de vérifier.',
      phoneNotEmpty:'le numéro de téléphone ne peut pas être vide.',
      addPhone:'Ajouter un numéro de téléphone',
      addAlEmail:'Ajouter une autre adresse électronique',
      verifySet :'Paramètre de vérification',
      addWayVerify:'Ajouter un moyen de vérifier',
      enterEmail:'Entrez votre adresse e-mail',
      enterPhone:'Entrez votre numéro de téléphone',
      enterCode:'Veuillez entrer le code que nous avons envoyé à',
      enterCodeTip:'Veuillez vérifier votre dossier spam et le signaler comme non spam ou ajouter « no-reply@multcloud.email » à votre liste blanche.',
      codeExpired:'Le code de vérification a expiré.',
      codeinCorrect:'Le code de vérification est incorrect, veuillez vérifier le code et réessayer.',
      verificationTurnOn:'La validation en deux étapes est activée',
      recoverAccess:'Si vous devez restaurer l\'accès à votre compte, ce code vous aidera. Vous devez l\'écrire et la conserver dans un endroit sûr. Nous vous recommandons vivement de ne pas stocker votre code de récupération sur votre appareil.',
      longValid:'Si vous aviez précédemment un code de récupération, il n\'est plus valable. Utilisez ce nouveau code à la place.',
      removeAll:'Supprimer tous les appareils ?',
      lostAccess:'Nous vous recommandons de le faire si vous avez perdu l\'accès à un appareil auquel vous avez fait confiance.',
      removeMethod:'Supprimer la méthode de vérification ?',
      removeMethodSure:'Êtes-vous sûr de vouloir supprimer la méthode de vérification ? Le supprimer signifie que vous ne pourrez pas l\'utiliser pour la vérification.',
      getRecode:'Générer un nouveau code',
      emailCode:'Envoyer un code par e-mail',
      TextCode:'Envoyez le code par SMS',
      useAccount:'Vous utilisez maintenant un compte temporaire, veuillez lier l\'e-mail et réessayer.',
      removeTrusted:'Supprimer tous les appareils de confiance',
      finish:'Terminer',
      newCode:'Votre nouveau code est',
      twoStep:'Vérification en deux étapes',
      twoStepis:'La vérification en deux étapes est',
      on:'Activé',
      off:'Désactivé',
      cancel:'Annuler',
      toManyCodeSend:'Trop de codes envoyés',
      verifyIdenti:'Vérifier l\'identité avec',
      codeCopied:'Code copié!',
      copyCode:'Copier le code',
      trustedDevice:'Appareils de confiance supprimés!',
      phoneValueTips:'Conseils : Veuillez supprimer le zéro initial, et supprimer tous les espaces, tirets ou parenthèses.',
  },
  website: {
    cloneNow: 'Cloner maintenant',
    addTaskNow: 'Ajouter une tâche et cloner maintenant',
    siteFromTitle: 'SITE WEB À SAUVEGARDER',
    siteFromDesc: 'Cliquez ici pour sélectionner les données du site source que vous souhaitez sauvegarder',
    siteToTitle: 'OÙ ENREGISTRER LA SAUVEGARDE',
    siteToDesc: 'Cliquez ici pour sélectionner le lecteur cloud ou le dossier de destination',
    sourceServers: 'Serveurs source',
    targetServers: 'Serveurs de destination',
    desc: 'Sauvegardez les fichiers et la base de données de votre site web dans le cloud, ou migrez votre site vers un nouvel hébergeur ou domaine.',
    addSite: 'Ajouter des fichiers du site web',
    addSiteMore: 'Ajouter plus de fichiers du site web',
    removeSite: 'Supprimer les fichiers du site web',
    addDb: 'Ajouter une base de données',
    addDbMore: 'Ajouter plus de bases de données du site web',
    removeDb: 'Supprimer la base de données du site web',
    cloneSameNodeWarning: 'La source et la destination du clone ne peuvent pas être le même nœud.',
    cloneTypeMismatchWarning: 'Les types source et destination du clone ne correspondent pas.',
    clonePairExistsWarning: 'La même combinaison source-cible existe déjà.',
    taskNameRequired: 'Veuillez saisir le nom de la tâche',
    switchToPlusForWebsiteTasks: 'Pour afficher les tâches de sauvegarde de site Web, vous devez passer à MultCloud Plus.',
    title: 'Sauvegarde et clonage de site Web',
},
  cloudBackup:{
      cloudBackup:'Sauvegarde de Cloud',
      setUpCloud:'Créer une tâche de sauvegarde de cloud pour sauvegarder les fichiers en ligne d\'un cloud à l\'autre.',
      filesBckupTarget: 'Répertoires cibles',
      filesBckup:'Fichiers à sauvegarder',
      selectSoure:'Cliquez ici pour sélectionner les fichiers de cloud source que vous souhaitez sauvegarder.',
      saveBackup:'Emplacement de sauvegarde',
      selectTarget:'Cliquez ici pour enregistrer le cloud cible pour enregistrer la sauvegarde.',
      backupNow:'Sauvegarder maintenant',
      canSelect:'Vous pouvez sélectionner 10000 articles au maximum',
      backupFiles:'Vous ne pouvez pas sauvegarder vos fichiers sur Google Photos.',
      notSelectEvernoteBackup: 'Vous ne pouvez pas sauvegarder vos fichiers sur Evernote.',
      backFlickr:'Vous ne pouvez pas sauvegarder vos fichiers sur Flickr.',
      thankSubscrib:'Merci d\avoir souscrit à notre service, vous avez maintenant un maximum de 10 fichiers sauvegardés simultanément.',
      maximunBack:'Vous avez maintenant un maximum de 2 fichiers sauvegardés simultanément. Passez à un service premium pour en avoir un maximum de 10 ! ',
      backSuccess:'Succès de sauvegarde',
      backFailure:'Défaut de sauvegarde',
      successBck:'Succès de la sauvegarde de tous les fichiers',
      taskCanceled:'La tâche a été annulée manuellement',
      notRestore:'Les fichiers à récupérer sont introuvables. Ils ont peut-être été supprimés.',
      selectVersions:'Sélectionner les versions',
      restoreOptions:'Options de restauration',
      selectFiles:'Sélectionnez les fichiers que vous souhaitez restaurer.',
      toRestore:'Veuillez sélectionner un fichier à restaurer.',
      originalLocation:'Emplacement original',
      thankRestore:'Merci d\'avoir souscrit à notre service, vous avez maintenant un maximum de 10 fichiers à restaurer simultanément.',
      restoreSimult:'Vous avez maintenant un maximum de 2 fichiers à restaurer simultanément. Passez à un service premium pour en avoir un maximum de 10 !',
      restoreSuccess:'Succès de restauration',
      restorePartial:'Succès de restauration partielle',
      restoreFailure:'Défaut de restauration',
      notRestore:'Les fichiers à récupérer sont introuvables. Ils ont peut-être été supprimés.',
      backupTime:'Temps de sauvegarde',
      changedFiles:'Fichiers modifiés',
      deleteVersion:'Etes-vous sûr de supprimer la version de sauvegarde ?',
      deleteFiles:'Supprimer les fichiers de cette version',
      keepLatest:'Conservez toujours le dernier fichier',
      overWriteFile:'Remplacer le fichier',
      skipFile:'Sauter le fichier',
      versions:'Versions',
      backupTask:'Tâche de Sauvegarde',
      readdCloud:'Réajoutez un Cloud',
      selectedCloud:'Certains clouds sélectionnés ont été ajoutés à MultCloud avant la sortie de Sauvegarde de Cloud, nous vous suggérons de les réajouter à MultCloud et de réessayer.',
      continueAnyway:'Contituez de toute façon',
      selectedHasAdded:'Le cloud sélectionné a été ajouté à MultCloud avant la sortie de Sauvegarde de Cloud, nous vous suggérons de le réajouter à MultCloud et de réessayer.',
      failCreate:'échec de la création de la tâche de sauvegarde.',
      failLoad:'échec du chargement',
      pleaseReAdd:'veuillez réajouter les clouds à MultCloud.',
      alreadyAdd:'Vous avez déjà ajouté le cloud',
      failRename:'échec du renommage, car le dossier correspondant est introuvable.',
      taskRuning:'La tâche est en cours, veuillez attendre qu\'elle se termine et réessayer.',
       //2021-08-07添加
      oneBackup:'Vous ne pouvez effectuer qu\'une seule tâche de sauvegarde ou de restauration à la fois',
      restoreTask:'Tâche de restauration',
      restoreOriginal:'Restaurer l\'emplacement original',
      restoreNewLocation:'Restaurer le nouvel emplacement',
       //2021-08-12添加
       backingUp:'Sauvegarde',
       restoring:'Restauration',
       restore:'Restaurer',
       backup:'Sauvegarde',
        //2021-08-17添加
      maxNum:'Le nombre maximum d\'éléments source est de 1000, veuillez sélectionner moins d\'éléments. P.S. Un dossier entier ne compte qu\'un seul élément.',
      maxLogs:'Note : Le résultat est tronqué. Jusqu\'à 1 000 fichiers échoués sont affichés ici.',
      backupDetails:'Détails de la sauvegarde',
      keepTwoFile:'Conserver deux fichiers',
      restoreDetails:'Restaurer les détails',
      longerDelete:'Cela peut prendre plus de temps s\'il y a un grand nombre de fichiers à supprimer.',
      notFoundAim:'Le répertoire cible est introuvable.',
      //2021-10-20
      backupNotWork:'Le service de sauvegarde ne fonctionne pas',
      //2021-10-28
      backupPartial:'Sauvegarde partielle réussie',
      configFile:'(Chargement du fichier de configuration)',
      successRestore:'Réussir la restauration de tous les fichiers.',
      notFind:'Ne trouvez pas le fichier de configuration, veuillez vérifier si le fichier de configuration existe et que la connexion entre le disque cloud et MultCloud est valide.',
      selectRestoreItems:'Veuillez sélectionner les fichiers à restaurer.',
      selectRestoreTotles:'Veuillez sélectionner un répertoire où restaurer.',
      original: 'Original',
      inTotalTip: '{count} fichiers, {size} au total',
      backupPathConflict: 'Le dossier de destination ne peut pas être le même que la source, ne peut pas se trouver à l\'intérieur de la source, et ne peut pas être le dossier qui contient la source. Veuillez sélectionner une autre destination.',
  },
  affiliateProgram: {
      leftTitle: "Devenir notre affilié",
      title: "Programme d'affiliation MultCloud ",
      headTips1: "Gagnez jusqu'à <span>50%</span> de commission.",
      headTips2: "Inscrivez-vous en quelques clics, c'est totalement<span>gratuit</span>.",
      headTips3: "Aucune condition supplémentaire, <span>tout le monde</span> peut devenir notre affilié !",
      signUpBtn: "Créez un compte d'affilié",
      tips: "Conseils : Si vous êtes déjà un affilié sur Cleverbridge, veuillez <a href=\"https://console.partnerize.com/campaigns/manage-campaigns/join-campaigns/advertiser-details/1011l331\" target=\"_blank\"> s'inscrire </a>.",
      howDoTipsTitle: "Comment ça marche",
      howDoTipsMsg: "Une fois que vous vous êtes inscrit et connecté à notre programme d'affiliation, vous trouverez AOMEI International Network Limited sous \"Campagnes - Rejoindre la Campagne\". Cliquez et confirmez votre adhésion. Une fois que vous avez rejoint notre campagne, vous verrez tous les produits MultCloud disponibles. Si quelqu'un met à niveau MultCloud par le biais de votre lien de parrainage, vous serez payé avec un taux de commission de <span>30%-50%</span>.",
      FAQsTitle: "FAQ du programme d'affiliation MultCloud",
      FAQ1: "Comment fonctionne le programme d'affiliation ?",
      answer1: "Une fois que votre client a payé via votre page de parrainage, vous recevrez votre paiement au début du mois suivant.",
      FAQ2: "Ça a l'air génial. Comment je m'inscris ?",
      answer2: "Vous pouvez vous inscrire en cliquant sur \"Créer un compte d'affilié\" ci-dessus. En quelques étapes, vous aurez votre compte d'affilié.",
      answerPs2: "Conseils : Une fois que vous vous êtes connecté à la console, vous pouvez trouver AOMEI International Network Limited sous l'onglet \"Campagnes\". Cliquez et confirmez votre adhésion.",
      FAQ3: "Combien de commissions est-ce que je reçois ?",
      answer3: "La commission diffère selon les plans d'abonnement. Par exemple, le taux de commission pour le plan Mensuel est de 30 %, mais pour le plan Illimité à vie, il sera de 50 %.",
      FAQ4: "Comment suis-je payé ?",
      answer4: "Cela dépend du“mode de paiement”vous avez spécifiée. Vous serez toujours payé au début de chaque mois.",
      answerPs4: "Conseils : Il n'y a pas de limite de montant minimum pour chaque paiement.",
      anyQuestionTitle: "Vous avez des questions ?",
      anyQuestionTip: "Soyez libre de contacter : <a href=\"mailto:affiliate@multcloud.com\" class=\"alink\">affiliate@multcloud.com</a>",
  },
  signUp: {
      pwdTip: "Mot de passe (8-16 caractères)",
      signingUp: "Inscription...",
      tips2: "En créant un compte, vous acceptez les <a href=\"https://www.multcloud.com/fr/terms\" class=\"alink\"> Conditions d'utilisation <a/>&nbsp;et&nbsp;<a href=\"https://www.multcloud.com/fr/policy\" class=\"alink\"> Politique de confidentialité<a/>.",
      emailPushTip: "En cochant cette case, vous acceptez de recevoir des e-mails de MultCloud concernant les produits, les mises à jour de services, les offres spéciales et les événements. Vous pouvez vous désabonner à tout moment.",
  },
  forgetPwd: {
      title: "Mot de passe oublié?",
      tip: "Entrez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
      sending: "Envoi du message ...",
      btnTxt: "Envoyer un e-mail de réinitialisation",
      tips1: "Vous avez oublié votre adresse e-mail?",
      tips2: "Envoyer un e-mail au support ",
      tips3: "et nous le retrouverons.",
  },
  balackFriday: {
      lastTip: "Dépêche-toi, l'offre se terminé bientôt  !",
      title: "Accès anticipé au Vendredi noir et au Cyber lundi pour obtenir un trafic de données cloud-à-cloud ILLIMITÉ avec 70% de réduction !",
    titleTip: "Dépêchez-vous jusqu'à épuisement du stock !",
  },
  christmas: {
    payTxt: "Soldes de Noël",
    popupTitle: "MULTCLOUD SUPER SOLDES",
    pageTitle: "Obtenez un trafic de données Cloud-à-Cloud ILLIMITÉ à vie avec {num}% DE RÉDUCTION !",
    pageTitle2: "Obtenez un trafic de données ILLIMITÉ à vie avec une réduction de {num}% !",
    paysysTitle: "DÉPÊCHEZ-VOUS, AVANT QU'IL NE DISPARAISSE !",
    popupTip1: "Trafic de données Cloud-à-Cloud ILLIMITÉ",
    popupTip2: "10 fils de transfert de données à haute vitesse",
    popupTip2Append: "Il y a 10 fils de transfert pour les utilisateurs payants et 2 fils de transfert pour les utilisateurs gratuits",
    popupTip3: "Transfert/synchronisation/sauvegarde planifiés",
    popupTip4: "Synchronisation en temps réel unidirectionnelle/ bidirectionnelle",
    popupTip4Append: "Il y a 7 modes de synchronisation supplémentaires pour les utilisateurs payants. Synchronisation miroir prise en charge",
    saledBtn: "ACHETER",
  },
  teamTransfer:{
      teamTransfer:'Transfert d\'équipe',
      transferMultiple:'Transférer plusieurs comptes d\'une plateforme cloud à une autre (Google Workspace, OneDrive for Business, Dropbox Business, Box for Business, Drive partagé).',
      businessCloud:'Si vous êtes un administrateur de clouds d\'entreprise, vous pouvez utiliser cette fonctionnalité pour migrer facilement tous les comptes d\'un cloud d\'entreprise à un autre. Par exemple, chaque utilisateur aura son propre dossier dans une plate-forme cloud, MultCloud peut associer automatiquement les dossiers de deux clouds professionnels différents et migrer les fichiers d\'un cloud à un autre.',
      clickSelect:'Cliquez ici pour sélectionner les services cloud d\'entreprise source à partir desquels vous souhaitez effectuer le transfert.',
      sourceAccount:'Comptes sources',
      targetAccounts:'Comptes cibles',
      autoMatch:'Correspondance automatique',
      likeTransfer:'Cliquez ici pour sélectionner les services cloud d\'entreprise cibles vers lesquels vous souhaitez effectuer le transfert.',
      youMust:'Vous devez',
      cloudService:' d\'abord ajouter un service cloud ',
      asAdmin:'d\'entreprise en tant qu\'administrateur.',
      combinations:'Correspondance automatique nettoiera les combinaisons actuelles, êtes-vous sûr de continuer ?',
      nosourceAccount:'Il n\'y a pas de compte source ou de compte cible.',
      noAccount:'Il n\'y a pas de comptes pour Correspondance automatique.',
      uploadCSV:'Uploader CSV',
      cleanCurrent :'L\'importation CSV nettoiera les combinaisons actuelles. Voulez-vous vraiment continuer?',
      csvFile:'Le fichier CSV que vous chargez doit correspondre',
      csvFormat:'au format .CSV.',
      matchCsv:'L\'organisation ne peut correspondre à aucune combinaison du fichier CSV, veuillez vérifier le fichier CSV et réessayer.',
      alreadyAdd:'Vous avez déjà ajouté la combinaison de ces deux comptes.',
      cleanAll:'Vous êtes sur le point de nettoyer toutes les combinaisons sélectionnées, êtes-vous sûr de continuer?',
      sure:'Oui, je suis sûr',
      allTransferred:'Conservez tous les fichiers transférés dans un seul dossier.',
      optionActivated:'Si cette option est activée, tous les fichiers transférés seront conservés dans un dossier du cloud cible. Par exemple, le répertoire source est Google Workspace\\simon@multcloud.com et le répertoire cible est OneDrive for Business\\peter@multcloud.com, tous les fichiers de Google Workspace\\simon@multcloud.com seront transférés vers OneDrive for Business\\peter@multcloud.com\\simon@multcloud.com lorsque cette option est activée.',
      organizationMigration:'Migration d\'organisation',
      //jimin新增
      downloadCSV:'Télécharger CSV',
      dontShow:'Ne plus afficher cela',
      notSelected:'Impossible de sélectionner le Drive partagé Google Workspace comme cloud cible pour la migration d\'équipe.',
      batchMatch:'Correspondance par lots',
      sourceCloud:'Ajouter un Cloud source',
      targetCloud:'Ajouter un Cloud cible',
      subTaskLimit:'Limite de sous-tâches',
      freeUsers:'Les utilisateurs gratuits peuvent créer 3 paires de sous-tâches dans une tâche de transfert d\'équipe, veuillez passer à la version premium et vous pouvez avoir 1000 sous-tâches dans une tâche de transfert d\'équipe.',
      mostTeamTransfer:'3 sous-tâches dans un transfert d\'équipe',
      substasksMost:'1000 sous-tâches dans un transfert d\'équipe',
      mostTasks:'Le nombre de sous-tâches peut être de 1000 au maximum.',
      timePassed:'Le temps que vous avez réglé est passé.',
  },
  shareTransfers: {
      logoMsg: '<span class="sf-logo-name">Transfert</span> <span class="sf-logo-first">MultCloud</span>',
      addFiles: 'Ajouter fichiers depuis Clouds',
      trnsfering: 'Transfert en cours...',
      sendingFile: 'Envoi de {num} fichier(s)',
      sendingSize: '{now} sur {all}',
      sendingTip: 'Création du lien de transfert, veuillez patienter.',
      cancelTransfer: 'Annuler ce transfert ?',
      createdTransfer: 'Transfert créé !',
      createShare: 'Transférer',
      signTitleByTransfer: 'Connecter à Multcloud pour continuer',
      signupTitleByTransfer: 'S\'inscrire à Multcloud pour continuer',
      transferTitle: 'Titre',
      transferDescription: 'Description',
      addFileTip: '{num} fichier(s) ajouté(s)',
      titleErrMsg: 'Le titre ne devrait pas dépasser 128 caractères.',
      desErrMsg: 'La description ne devrait pas dépasser 512 caractères.',
      folder: 'Dossier',
  },
  summerSale: {
    titleTip: 'Bonjour été',
    titleTip2: 'Trafic de données cloud à cloud ILLIMITÉ et gérez tous vos souvenirs d\'été sans effort à un prix doux !',
    bottomTip: '- MEILLEURE OFFRE DE LA SAISON –',
  },
  halloweenSale: {
    titleTip2: 'Économisez jusqu\'à 70 % en Pas d\'entourloupe, juste des friandises avec un trafic de données cloud-à-cloud ILLIMITÉ ! ',
    bottomTip: 'Dépêchez-vous ! Avant que ce soit fini.',
},
newYear: {
    payTxt: "SOLDES DE NOUVEL AN",
    titleTip: 'Célébrez la nouvelle année avec une super réduction de 70 % sur le trafic de données ILLIMITÉ de cloud à cloud !',
    bottomTip: 'Vite ! Avant que ça se termine !',
},
backToSchool: {
    titleTip2: 'Bénéficiez d\'un trafic de données cloud à cloud ILLIMITÉ et gérez tous vos souvenirs scolaires à un prix avantageux !',
    bottomTip: '- MEILLEURE OFFRE DE LA SAISON –',
},
blackFriday: {
    titleTip: 'Obtenez 70% de réduction sur traffic de données cloud-à-cloud ILLIMITÉ.',
    bottomTip: 'Vite ! Avant que ça se termine !',
},
xmas: {
    titleTip: 'Profitez d\'une réduction festive de 70 % sur le trafic de données ILLIMITÉ de cloud à cloud ce Noël !',
    bottomTip: 'Vite ! Avant que ça se termine !',
},
license: {
    codeTitle: 'Entrer la licence',
    codeTipTitle: 'Entrer le Code de Licence',
    codeTipText: 'Si vous disposez d\'un code de licence, vous pouvez l\'utiliser pour activer le service premium.',
    codeTipTextVip: 'Si vous disposez d\'un code de licence, vous pouvez l\'utiliser pour passer à un service plus avancé.',
    codeFooter: 'Si vous avez besoin d\'aide, n\'hésitez pas à nous contacter : ',
    showTitle: 'Code de licence',
    showTip: 'Le code de licence est : ',
    codeSucTitle: 'Service Premium activé',
    codeSucTip: 'Service Premium activé !',
},
filters: {
    taskList: {
        typeName: 'Type',
        type: {
            all: 'Liste complète',
            copy: 'Tâches temp',
            transfer: 'Transfert de Cloud',
            sync: 'Synchronisation de Cloud',
            backup: 'Sauvegarde de Cloud',
            business: 'Transfert d\'équipe',
            remoteUpload: 'Téléchargement à distance',
            emailMigration: 'Migration E-mail',
            restore: 'Restauration depuis le cloud',
        },
        statusName: 'État',
        status: {
            all: 'Tous les états',
            preset: 'Préréglé',
            running: 'En cours d\'exécution',
            success: 'Succès',
            patial: 'Succès Partiel',
            failed: 'Échec',
            canceled: 'Annulé',
        },
        dateName: "Date",
        date: {
            all: 'Tous les temps',
            today: 'Aujourd\'hui',
            latestWeek: 'Dernière semaine',
            latestMonth: 'Dernier mois',
            customDate: 'Date personnalisée',
        },
    }
},
schedule: {
    week1: "Dimanche",
    week2: "Lundi",
    week3: "Mardi",
    week4: "Mercredi",
    week5: "Jeudi",
    week6: "Vendredi",
    week7: "Samedi",
},
inputTab: {
    filterMessage: 'Appuyez sur Entrée pour ajouter l\'extension de fichier',
}
}



// WEBPACK FOOTER //
// ./src/assets/i18n/france.js